import LABEL from '../../business-const/Label/Label'

import HARDCODE from '../../business-const/HardCode/HardCode'

import {
    importaApoliceAllianz,
    importaListaComissoesAllianz,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceAllianz'

import {
    importaConsorcioBensImoveisAdemicon,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceAdemicon'

import {
    importaApoliceAzos,
    importaApoliceAzosNovoLayout,
    importaListaApolicesAzosImplantacao,
    importaListaApolicesAzosImplantacaoSemAgente,
    importaListaCobrancasAzos,
    importaListaComissoesAzos,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceAzos'

import {
    importaApoliceBradescoVidaInteiraVivaMais,
    importaApoliceBradescoMultiPlanoVivaMais,
    importaListaComissoesBradesco,
    importaCotacaoBradescoTabelaEvolucaoValorResgate,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceBradesco'

import {
    importaPosicaoInvestimentosBTG,
    importaPosicaoInvestimentosBTGLayout2,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceBTG'

import {
    importaPropostaIcatuHorizonte,
    importaPropostaIcatuEssencial,
    importaListaPropostasIcatu,
    importaApoliceIcatuHorizonte,
    importaApoliceIcatuEssencialSuperAPVidaDigital,
    importaApoliceIcatu,
    importaListaApolicesIcatuImplantacao,
    importaListaApolicesIcatuImplantacaoSegundoLayout,
    importaListaComissoesIcatu,
    importaListaComissoesIcatuSegundoLayout,
    importaCotacaoIcatuTabelaEvolucaoValorResgate,
    importaCotacaoIcatuTabelaEvolucaoValorResgateNovoLayout,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceIcatu'

import {
    importaPosicaoInvestimentosIonItau,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceIonItau'

import {
    importaPosicaoInvestimentosItau,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceItau'

import {
    importaListaApolicesMAPFRE,
    importaListaCobrancasMAPFRE,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceMAPFRE'

import {
    importaPropostaMAG,
    importaListaPropostasMAG,
    importaListaPropostasMAGNovoLayout,
    importaListaPropostasImplantacaoMAG,
    importaApoliceMAGPrivateSolutions,
    importaApoliceMAGVidaToda,
    importaListaApolicesMAGImplantacao,
    importaListaApolicesMAGImplantacaoSegundoLayout,
    importaListaApolicesMAGImplantacaoTerceiroLayout,
    importaListaCobrancasMAG,
    importaListaComissoesMAG,
    importaListaComissoesMAGSegundoLayout,
    importaCotacaoMAGTabelaEvolucaoValorResgate,
    importaCotacaoMAGTabelaEvolucaoValorResgateNovoLayout,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceMAG'

import {
    importaPropostaMetLife,
    importaPropostaMetLifeNovoLayout,
    importaListaPropostasImplantacaoMetLife,
    importaListaPropostasMetLife,
    importaApoliceMetLife,
    importaListaApolicesMetLife,
    //importaApoliceMetLifeNovoLayout,
    importaListaApolicesMetLifeImplantacao,
    importaListaComissoesMetLife,
    importaCotacaoMetLifeTabelaEvolucaoValorResgate,
    importaCotacaoMetLifeTabelaEvolucaoValorResgateCartaAdendo,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceMetLife'

import {
    importaApoliceOmint,
    importaListaCobrancasOmint,
    importaListaComissoesOmint,
    importaListaComissoesOmintSegundoLayout,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceOmint'

import {
    importaListaTransferenciaClientesOutras,
    importaListaClientesAgentesOutras,
    importaListaApolicesAgentesOutras,
    importaParcelas,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceOutras'

import {
    importaApolicePortoSeguro,
    importaConsorcioBensImoveisPortoSeguro,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServicePortoSeguro'

import {
    importaPropostaPrudential,
    importaApolicePrudential,
    importaApolicePrudentialSiteCliente,
    importaListaApolicesPrudentialImplantacaoConsultorFinanceiroLP,
    importaListaApolicesPrudentialImplantacaoSemAgente,
    importaListaCobrancasPrudential,
    importaListaComissoesPrudential,
    importaListaComissoesPrudentialSegundoLayout,
    importaListaRecapturePrudential,
    importaCotacaoPrudentialTabelaEvolucaoValorResgate,
    importaCotacaoPrudentialTabelaEvolucaoValorResgateLifePlanner,
    importaCotacaoPrudentialXPTabelaEvolucaoValorResgateAtual,
    importaCotacaoPrudentialXPTabelaEvolucaoValorResgateAntiga,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServicePrudential'

import {
    importaPosicaoInvestimentosSafra,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceSafra'

import {
    importaApoliceSantander,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceSantander'

import {
    importaPropostaXP,
    importaApoliceXP,
    importaListaApolicesXPImplantacao,
    importaFichaCadastralXP,
    importaPosicaoInvestimentosXP,
    importaCotacaoXPTabelaEvolucaoValorResgate,
} from '../../views/clientes/integracaoClienteArquivo-list/IntegracaoClienteArquivoServiceXP'

import {
    SvgImageParceirosAdemiconConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Ademicon/SvgImageParceirosAdemicon'

import {
    SvgImageParceirosAncoraConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Ancora/SvgImageParceirosAncora'

import {
    SvgImageParceirosBancorbrasConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Bancorbras/SvgImageParceirosBancorbras'

import {
    SvgImageParceirosBradescoLogo,
    SvgImageParceirosBradescoConsorcioLogo,
} from '../../business-components/SvgImage/Parceiros/Bradesco/SvgImageParceirosBradesco'

import {
    SvgImageParceirosCNPConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/CNP/SvgImageParceirosCNP'

import {
    SvgImageParceirosEmbraconConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Embracon/SvgImageParceirosEmbracon'

import {
    SvgImageParceirosIcatuLogo
} from '../../business-components/SvgImage/Parceiros/Icatu/SvgImageParceirosIcatu'

import {
    SvgImageParceirosItauConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Itau/SvgImageParceirosItau' 

import {
    SvgImageParceirosMAPFREConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/MAPFRE/SvgImageParceirosMAPFRE' 

import {
    SvgImageParceirosMetLifeLogo
} from '../../business-components/SvgImage/Parceiros/MetLife/SvgImageParceirosMetLife'

import {
    SvgImageParceirosMAGLogo
} from '../../business-components/SvgImage/Parceiros/MAG/SvgImageParceirosMAG'

import {
    SvgImageParceirosPrudentialLogo
} from '../../business-components/SvgImage/Parceiros/Prudential/SvgImageParceirosPrudential'

import {
    SvgImageParceirosPortoSeguroLogo,
    SvgImageParceirosPortoSeguroConsorcioLogo,
} from '../../business-components/SvgImage/Parceiros/PortoSeguro/SvgImageParceirosPortoSeguro'

import {
    SvgImageParceirosRaconConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Racon/SvgImageParceirosRacon'

import {
    SvgImageParceirosRodobensConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Rodobens/SvgImageParceirosRodobens'

import {
    SvgImageParceirosSantanderConsorcioLogo
} from '../../business-components/SvgImage/Parceiros/Santander/SvgImageParceirosSantander' 

import {
    SvgImageParceirosServopaConsorcioLogo,
} from '../../business-components/SvgImage/Parceiros/Servopa/SvgImageParceirosServopa'

import {
    SvgImageParceirosUneConsorcioLogo,
} from '../../business-components/SvgImage/Parceiros/Une/SvgImageParceirosUne'

import {
    SvgImageParceirosXPLogo,
    SvgImageParceirosXPConsorcioLogo,
} from '../../business-components/SvgImage/Parceiros/XP/SvgImageParceirosXP'



const tipoCoberturaSeguroVidaAllianz = [
    {id: 'MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    //{id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    //{id: 'MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    //{id: 'INVALIDEZ PERMANENTE TOTAL POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal/*Parcial*/},
    //{id: 'INVALIDEZ PERMANENTE TOTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal/*Parcial*/},
    //{id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    //{id: 'ASSISTÊNCIA FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    //{id: 'ASSISTÊNCIA FUNERAL INDIVIDUAL ATÉ', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    //{id: 'ASSISTÊNCIA FUNERAL INDIVIDUAL + PAIS ATÉ', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    //{id: 'CIRURGIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    //{id: 'DIÁRIA DE INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'DIT - DIÁRIA POR INCAPACIDADE TEMP. (ATÉ 180 DIÁRIAS)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
    {id: 'DIT - DIÁRIA POR INCAPACIDADE TEMP. (ATÉ 365 DIÁRIAS)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
    //{id: 'RUPTURA E FRATURAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaQuebraOssos},
]



const statusApoliceAzos = [
    {id: 'VIGENTE', idConversao: HARDCODE.idStatusApoliceAtiva},
    {id: 'CANCELADA', idConversao: HARDCODE.idStatusApoliceCancelada},
]

const tipoCoberturaSeguroVidaAzos = [
    {id: 'COBERTURA DE MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'INVALIDEZ PERMANENTE TOTAL POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal/*Parcial*/},
    {id: 'INVALIDEZ PERMANENTE TOTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal/*Parcial*/},//NOVO
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'ASSISTÊNCIA FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'ASSISTÊNCIA FUNERAL INDIVIDUAL ATÉ', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'ASSISTÊNCIA FUNERAL INDIVIDUAL + PAIS ATÉ', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//05/2026
    {id: 'CIRURGIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    {id: 'DIÁRIA DE INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'RENDA POR INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
    {id: 'RUPTURA E FRATURAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaQuebraOssos}, // 04/2026
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
]



const tipoCoberturaSeguroVidaBradesco = [
    {id: 'MORTE VITALICIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    //{id: 'MORTE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    //{id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    //{id: 'INVALIDEZ PERMANENTE TOTAL POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal/*Parcial*/},
    //{id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    //{id: 'ASSISTÊNCIA FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'SEGURO FUNERAL INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//NOVO
    //{id: 'CIRURGIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    //{id: 'DIÁRIA DE INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    //{id: 'RENDA POR INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
]



const tipoRecursoFinanceiroBTG = [
    {id: 'PÓS-FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPosFixado},
    {id: 'PÓS-FIXADO-ENCERRADOS', idConversao: HARDCODE.idTipoRecursoFinanceiroPosFixado},
    {id: 'INFLAÇÃO', idConversao: HARDCODE.idTipoRecursoFinanceiroInflacao},
    {id: 'PRÉ-FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPreFixado},
    //{id: 'FUNDOS LISTADOS', idConversao: HARDCODE.idTipoRecursoFinanceiroFundosListados},
    {id: 'RETORNO-ABSOLUTO-(MM)', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
    {id: 'RETORNO-ABSOLUTO-(MM)-ENCERRADOS', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
    {id: 'ALTERNATIVO', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
    {id: 'RENDA-VARIÁVEL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
    //{id: 'RENDA VARIÁVEL BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
    //{id: 'RENDA VARIÁVEL GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
    {id: 'RENDA-FIXA', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa}, // suposição
    //{id: 'RENDA FIXA BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
    //{id: 'RENDA FIXA GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
    {id: 'INTERNACIONAL', idConversao: HARDCODE.idTipoRecursoFinanceiroInternacional}, //suposição
    
]



const statusApoliceIcatu = [
    {id: 'EMITIDA', idConversao: HARDCODE.idStatusApoliceAtiva},
    {id: 'CANCELADA', idConversao: HARDCODE.idStatusApoliceCancelada},
]

const tipoCoberturaSeguroVidaIcatu = [
    // Proposta
    {id: 'MORTE NATURAL OU ACIDENTAL - COM VIGÊNCIA TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'MORTE NATURAL OU ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'INDENIZAÇÃO ESPECIAL DE MORTE POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'INDENIZAÇÃO ESPECIAL DE INVALIDEZ POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'SERVIÇO DE ASSISTÊNCIA FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'DIARIA POR INTERNACAO HOSPITALAR (DIH)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'DIÁRIA POR INTERNAÇÃO HOSPITALAR (DIH)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    // Apólice
    {id: 'MORTE QUALQUER CAUSA VITALÍCIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'MORTE QUALQUER CAUSA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'INDENIZAÇÃO ESPECIAL POR MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'ASSISTÊNCIA FUNERAL INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'ASSISTÊNCIA FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'ASSISTÊNCIA FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'AUXÍLIO FINANCEIRO IMEDIATO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'DIÁRIA POR INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},
    {id: 'ADIANTAMENTO POR DOENÇA EM ESTÁGIO TERMINAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'INVALIDEZ PERMANENTE TOTAL OU PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'INVALIDEZ PERMANENTE TOTAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal},//mais recente
    {id: 'INDENIZAÇÃO ESPECIAL DE INVALIDEZ POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
    {id: 'INVALIDEZ FUNCIONAL PERMANENTE TOTAL POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    // Proposta e Apólice
    {id: 'DIÁRIA POR INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
    {id: 'APOIO FINANCEIRO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//confirmar a classificação
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
]

const formaPagtoPremioIcatu = [
    {id: 'STONE MUNDIPAG', idConversao: HARDCODE.idTipoFormaPagtoCartaoCredito},
    {id: '237 - BOLETO', idConversao: HARDCODE.idTipoFormaPagtoPremioBoleto},
    {id: 'DEBITO EM CONTA - SANTANDER', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'DEBITO EM CONTA - CAIXA ECO', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'DEBITO EM CONTA - ITAÚ', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'DEBITO EM CONTA - B.BRASIL', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'DEBITO EM CONTA - BRADESCO', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'DÉBITO EM CONTA - INTER', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'DÉBITO EM CONTA-UNICRED SC/PR', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'DEBITO C/C SICREDI', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: '756 - DEB C/C - CONV: 8490080', idConversao: HARDCODE.idTipoFormaPagtoPremioDebito},
    {id: 'PIX', idConversao: HARDCODE.idTipoFormaPagtoPremioPix},
]



const statusPropostaMAG = [
    {id: 'PENDENTE', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'ACEITA', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'ELEGÍVEL PARA RECUSA', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'EM ANÁLISE', idConversao: HARDCODE.idStatusPropostaEmAnalise},
    {id: 'ACEITE AUTOMÁTICO', idConversao: HARDCODE.idStatusPropostaEmAnalise},
    {id: 'EM CONFERÊNCIA', idConversao: HARDCODE.idStatusPropostaEmAnalise},
    {id: 'SUSPENSA', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'IMPLANTADA', idConversao: HARDCODE.idStatusPropostaImplantada},
    {id: 'IMPLANTADA - EMITIDA', idConversao: HARDCODE.idStatusPropostaPaga},
    {id: 'IMPLANTADA - CANCELADA', idConversao: HARDCODE.idStatusPropostaRecusada},
    {id: 'IMPLANTADA - EMITIDA CANCELADA', idConversao: HARDCODE.idStatusPropostaRecusada},//novo
    {id: 'CANCELADA', idConversao: HARDCODE.idStatusPropostaRecusada},
    {id: 'RECUSADA', idConversao: HARDCODE.idStatusPropostaRecusada},
]

const tipoPeriodicidadePagtoPremioMAG = [
    {id: 0, idConversao: HARDCODE.idTipoPeriodicidadeUnica},
    {id: 30, idConversao: HARDCODE.idTipoPeriodicidadeMensal},
    {id: 90, idConversao: HARDCODE.idTipoPeriodicidadeTrimestral},
    {id: 180, idConversao: HARDCODE.idTipoPeriodicidadeSemestral},
    {id: 365, idConversao: HARDCODE.idTipoPeriodicidadeAnual},
]

const statusApoliceMAG = [
    {id: 'ATIVO', idConversao: HARDCODE.idStatusApoliceAtiva},
    {id: 'ATIVO - SALDAMENTO', idConversao: HARDCODE.idStatusApoliceAtiva},
    {id: 'CANCELADO', idConversao: HARDCODE.idStatusApoliceCancelada},
    {id: 'CANCELADO POR BENEFICIO', idConversao: HARDCODE.idStatusApoliceSinistrada},
    {id: 'ATIVO - REMIDO', idConversao: HARDCODE.idStatusApoliceAtiva}, // 10/2026
]

const tipoCoberturaSeguroVidaMAG = [
    {id: 'DIT COM LER E DORT', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //NOVO
    {id: 'DIT COM LER E IPA NORMAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //NOVO NOVO
    {id: 'DIT – BENEF. INVALIDEZ POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//Novo
    {id: 'DIT – BENEF. INCAPACIDADE TEMP. (COB. PRINCIPAL)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //Novo
    {id: 'DIT – BENEF. POR MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental}, //Novo
    {id: 'DIT – BENEF. INCAPACIDADE TEMP. (COB. PRINCIPAL)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //Novo
    {id: 'DIT - DIÁRIA POR INCAPACIDADE TEMPORÁRIA (COB. PRINCIPAL)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //Novo
    {id: 'DIT – DIÁRIA POR INCAPACIDADE TEMPORÁRIA (COB. PRINCIPAL)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //Novo
    {id: 'DIT - COB. PRINCIPAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //Novo Novo Novo
    {id: 'DIT - BENEFÍCIO POR MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental}, //Novo
    {id: 'DIT - INVALIDEZ POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'DIT MÉDICOS + MQC 10 DIAS: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT MÉDICOS + MQC 10 DIAS - RIDER: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT MÉDICOS + MQC 7 DIAS: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT MÉDICOS + MQC 7 DIAS - RIDER: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT + MQC 7 DIAS: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT + MQC 7 DIAS - RIDER: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT + MQC 10 DIAS: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT + MQC 10 DIAS - RIDER: MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Caso Especial
    {id: 'DIT + MQC 7 DIAS - 2397', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Checar
    {id: 'DIT + MQC 7 DIAS - RIDER - 2419', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Checar
    {id: 'DIT + MQC 10 DIAS - 2399', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Checar
    {id: 'DIT + MQC 10 DIAS - RIDER - 2419', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Checar
    {id: 'DIT + MQC 10 DIAS - RIDER - 2420', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Checar
    {id: 'DIT + MAC + IPAM 7 DIAS - 2396', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Checar
    {id: 'DIT + MAC + IPAM - 7 DIAS - RIDER - 2421', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//NOVO NOVO
    {id: 'DIT + MAC + IPAM 10 DIAS - 2398', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Checar
    {id: 'DIT + MAC + IPAM 10 DIAS - RIDER - 2422', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Checar
    {id: 'DIT MÉDICOS + MQC 7 DIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Checar
    {id: 'DIT MÉDICOS + MQC 10 DIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTradicional},//Checar
    {id: 'DIT MÉDICOS + MAC + IPAM 7 DIAS - 2400', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Checar
    {id: 'DIT MÉDICOS + MAC + IPAM 7 DIAS - RIDER - 2532', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Checar
    {id: 'DIT MÉDICOS + MAC + IPA 10 DIAS - 2403', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Checar
    {id: 'DIT MÉDICOS + MAC + IPAM 10 DIAS - RIDER - 2434', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Checar
    {id: 'PCHV MÓDULO II - PCHV + DIT - 2182', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},//Checar
    {id: 'MASTER ACIDENTES DOMICILIARES - 2342', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},//Checar
    {id: 'DIÁRIA POR INCAPACIDADE TEMPORÁRIA POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},//Novo
    {id: 'DIARIA POR INCAPACIDADE TEMPORÁRIA POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},//Novo
    {id: 'DIÁRIA DE INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},//novo
    {id: 'DIARIA DE INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},//Proposta
    {id: 'DIARIA DE INCAPACIDADE TEMPORARIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},//proposta
    {id: 'DIÁRIA INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},//proposta
    {id: 'PRAZO CERTO: PRAZO CERTO - BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//Caso Especial
    {id: 'PRAZO CERTO – BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//Caso Especial
    {id: 'PRAZO CERTO - TERM LIFE - 1510', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//Caso Especial Novo
    {id: 'PRAZO CERTO - 3085', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//Caso Especial Novo
    {id: '2113MORTE + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario, descricao: 'MORTE + ADT + DPI'}, //NOVO
    {id: '2435MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario, descricao: 'MORTE'}, //RECENTE
    {id: '2420MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario, descricao: 'MORTE'}, //RECENTE
    {id: '1753MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario, descricao: 'MORTE'}, //RECENTE recente
    {id: 'TERM LIFE - MORTE + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//Proposta
    {id: 'TERM LIFE - MORTE+ADT+DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//Proposta
    {id: 'TERM LIFE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//Proposta
    {id: '3109 MORTE + ADT + DPI - 10 ANOS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira, descricao: 'MORTE + ADT + DPI - 10 ANOS'}, //RECENTE recente recente
    {id: '2395 MORTE + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario, descricao: 'MORTE + ADT + DPI'},//novo novo novo
    {id: '3117 MORTE + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario, descricao: 'MORTE + ADT + DPI'}, //NOVO novo novo
    {id: 'MORTE + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'VIDA INTEIRA RESGATÁVEL - MORTE 10 ANOS + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Recente
    {id: 'VIDA INTEIRA RESGATÁVEL - MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Recente
    {id: 'VIDA INTEIRA RESGATAVEL - MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Recente NOVO5
    {id: 'VIDA INTEIRA – BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//novo
    {id: 'VIDA INTEIRA - BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Caso Especial
    {id: 'VIDA INTEIRA - 2694', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Caso Especial
    {id: 'VIDA INTEIRA - 3082', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//RECENTE RECENTE
    {id: 'VIDA PLENA - BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//05/2026
    {id: 'CAPITAL SEGURADO POR MORTE - 1546', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Checar
    {id: 'WHOLE LIFE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Recente
    {id: 'MORTE VIDA INTEIRA RESGATÁVEL - BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Novo
    {id: 'MORTE VIDA INTEIRA RESGATÁVEL – BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//Novo
    {id: 'MORTE DECRESCENTE + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteiraDecrescente},
    {id: 'MORTE DECRESCENTE+ADT+DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteiraDecrescente},
    {id: 'MORTE DECRESCENTE 10 ANOS + ADT + DPI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteiraDecrescente},//Proposta
    {id: '1754 - MORTE DECRESCENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteiraDecrescente},//novo novo novo
    {id: 'MORTE QUALQUER CAUSA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//05/2026
    {id: 'BENEFÍCIO POR MORTE VITALÍCIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'BENEFÍCIO POR MORTE VITALÍCIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'BENEF. MORTE VITALICIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//novo novo novo
    {id: 'TOTAL – BENEFÍCIO POR MORTE – COB. PRINCIPAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//recente
    {id: 'BENEF. MORTE TEMPORARIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//recente
    {id: 'TOTAL – BENEFÍCIO POR MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//recente
    {id: 'BENEFÍCIO POR MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'BENEFICIO POR MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//Novo
    {id: 'BENEF. MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//novo
    {id: '2694 – BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//06/2026
    {id: 'BENEFÍCIO POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//novo
    {id: 'DOENÇAS GRAVES PREMIUM', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DOENÇAS GRAVES PLUS RIDER', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves}, // 04/2026
    {id: 'DOENÇAS GRAVES PLUS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DOENÇAS GRAVES MULTI RIDER', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves}, // 07/2026
    {id: 'DOENÇAS GRAVES ESSENCIAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},//RECENTE
    {id: 'TOTAL – DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},//recente
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves}, //NOVO
    {id: 'CIRUGIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    {id: 'CIRURGIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},//Novo
    {id: 'CHECK UP MEDICO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCheckUpMedico},//05/2026
    {id: 'SAF - SEGURO DE ASSISTÊNCIA FUNERAL SUPER LUXO FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO
    {id: 'SAF SEGURO DE ASSISTENCIA FUNERAL SUPER LUXO FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO
    {id: 'SAF PREMIUM FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO NOVO
    {id: 'SAF PLUS FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO NOVO NOVO5
    {id: 'SAF ESSENCIAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO NOVO NOVO5
    {id: 'SAF PREMIUM INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO NOVO NOVO
    {id: 'SAF PLUS INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO NOVO NOVO NOVO5
    {id: 'SAF ESSENCIAL INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, //NOVO NOVO NOVO NOVO5
    {id: 'SAF - INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, // 03/2026
    {id: 'SAF - FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, // 03/2026
    {id: 'SEGURO ASSISTENCIA FUNERAL INDIVIDUAL SUPERLUXO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'SEGURO ASSISTENCIA FUNERAL FAMILIAR SUPERLUXO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    //{id: 'SEGURO DE ASSISTENCIA FUNERAL LUXO INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//N-o-v-o
    {id: 'SEGURO DE ASSISTÊNCIA FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SEGURO DE ASSISTENCIA FUNERAL LUXO INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Caso Especial
    {id: 'SEGURO DE ASSISTENCIA FUNERAL INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Caso Especial
    {id: 'SEGURO DE ASSISTENCIA FUNERAL LUXO FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Caso Especial
    {id: 'SEGURO DE ASSISTÊNCIA FUNERAL PREMIUM INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, // NOVO6
    {id: 'SEGURO DE ASSISTÊNCIA FUNERAL PREMIUM FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral}, // NOVO7
    {id: 'SEGURO DE ASSISTÊNCIA FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'SEGURO ASSISTÊNCIA FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'SEGURO ASSISTENCIA FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Proposta
    {id: 'SEG. ASSIST. FUNERAL LUXO FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//novo
    {id: 'SEG. ASSIST. FUNERAL SUPERLUXO INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SEG. ASSIST. FUNERAL SUPERLUXO FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SAF SEGURO DE ASSISTENCIA FUNERAL SUPER LUXO INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SAF SEGURO DE ASSISTENCIA FUNERAL SUPER LUXO FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'FUNERAL FAMILIAR SUPERLUXO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SAF FAMILIAR SUPERLUXO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SAF FAMILIAR LUXO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SAF INDIVIDUAL SUPERLUXO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'SAF INDIVIDUAL LUXO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo NOVO5
    {id: 'ASSISTENCIA FUNERAL LUXO FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Mais Recente
    {id: 'DIARIA POR INTERNACAO HOSPITALAR VIDA INTEIRA RESGATÁVEL - DIÁRIA POR INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//Novo
    {id: 'DIÁRIA POR INTERNAÇÃO HOSPITALAR – 150 DIÁRIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'DIÁRIA POR INTERNAÇÃO HOSPITALAR – 200 DIÁRIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//Novo
    {id: 'DIÁRIA POR INTERNAÇÃO HOSPITALAR – 250 DIÁRIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//Novo
    {id: 'DIH - 150 DIÁRIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//Novo
    {id: 'DIH - 200 DIÁRIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//Novo
    {id: 'DIH - 250 DIÁRIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//Novo
    {id: 'INTERNAÇÃO HOSPITALAR 150 DIARIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//RECENTE
    {id: 'INTERNAÇÃO HOSPITALAR 200 DIARIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//N-o-v-o
    {id: 'INTERNAÇÃO HOSPITALAR 250 DIARIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//RECENTE
    {id: 'INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//Proposta
    {id: 'ADICIONAL UTI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAdicionalUTI},
    {id: 'ADICIONAL – UTI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAdicionalUTI},
    {id: 'ADICIONAL - UTI', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAdicionalUTI},
    {id: 'FERIDAS ACIDENTAIS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaFeridasAcidentais},
    {id: 'REEMBOLSO AMBULANCIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaReembolsoAmbulancia},
    {id: 'REEMBOLSO EMERGENCIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaReembolsoEmergencia},
    {id: 'IPA MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'IPA COM MAJORAÇÃO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial}, //novo
    {id: 'CAPTAL SEGURADO POR IPA - 1537', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial}, //novo
    {id: 'INVALIDEZ POR ACIDENTE VIDA INTEIRA RESGATÁVEL - INVALIDEZ POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//Novo
    {id: 'INVALIDEZ POR ACIDENTE COM MAJORAÇÃO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//Novo
    {id: 'INVALIDEZ POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'INVALIDEZ POR ACIDENTE (COB.PRINCIPAL)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//novo
    {id: 'INVALIDEZ POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//novo
    {id: 'ASSISTÊNCIA PERSONAL CARE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//novo
    {id: 'INVALIDEZ PERMANENTE TOTAL OU PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//Novo
    {id: 'INVALIDEZ PERMANENTE POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'INVALIDEZ PERMANE NTE POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'INVALIDEZ TOTAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal/*Parcial*/},//Proposta
    {id: 'IPTA - RIDER - 2427', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//Proposta
    {id: 'IPTA - 1548', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//Proposta
    {id: 'TOTAL – INVALIDEZ POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//recente
    {id: 'INVALIDEZ FUNCIONAL POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},//novo
    {id: 'INVALIDEZ FUNCIONAL PERMANENTE TOTAL POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'INVALIDEZ POR DOENÇA VIDA INTEIRA RESGATÁVEL - INVALIDEZ POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},//Novo
    {id: 'INVALIDEZ POR DOENÇA MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},//N-o-v-o
    {id: 'INVALIDEZ POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},//Novo
    {id: 'CAPITAL SEGURADO POR IFPD/IPA - 1538', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},//Novo
    {id: 'ASSISTENCIA PREMIUM - AUTO E MOTO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaAutoMoto},//proposta
    {id: 'ASSISTENCIA PREMIUM - RESIDENCIAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaAutoMoto},//proposta
    {id: 'ASSISTENCIA PREMIUM - DESCONTO EM MEDICAMENTOS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaDescontoMedicamentos},//proposta
    {id: 'ASSISTÊNCIA TELESSAUDE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaTelesSaude},//RECENTE
    {id: 'ASSISTÊNCIA SAÚDE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaSaude},//07/2026
    {id: 'ASSISTENCIA INVIDA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaSaude},//11/2026
    {id: 'TELEMEDICINA POR VÍDEO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaSaude},//10/2026
    {id: 'ASSISTÊNCIA RESIDENCIAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaResidencial},//07/2026
    {id: 'SORTEIO MENSAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaOutrosSorteioMensal},//05/2026
    {id: 'CHECK-UP START', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaTelesSaude},// 04/2026
    {id: 'SEGURANÇA EXCLUSIVA PREMIUM', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//proposta
    {id: 'RENDA POR INVALIDEZ', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteRenda},//RECENTE
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental}, //NOVO
    {id: 'MORTE ACIDENAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental}, //Proposta
    {id: 'MORTE POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental}, //Proposta
    {id: '2096 – MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira}, //RECENTE
    {id: '2011 – MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira}, //RECENTE
    {id: '2104 – MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira}, //RECENTE
    {id: '2399 – MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario}, //RECENTE
    {id: '2397 – MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario}, //RECENTE
    {id: '2401 – MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario}, //RECENTE
    {id: '2401 - MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario}, //BEM RECENTE
    {id: 'SEGURO DOTAL MISTO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDotalMisto}, // 03/2026
    {id: 'VIDA TODA TOTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario}, // 03/2026
    {id: 'VIDA TODA VGBL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario}, // 03/2026
    {id: 'INVALIDEZ CAPITALIZAÇÃO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial}, // 03/2026
]

const statusCoberturaMAG = [
    {id: 'ATIVA', idConversao: HARDCODE.idStatusCoberturaAtivaPagandoPremio},
    {id: 'PRESCRIÇÃO BENEFÍCIO', idConversao: HARDCODE.idStatusCoberturaAtivaPagandoPremio},//NOVO NOVO
    {id: 'REMIDO', idConversao: HARDCODE.idStatusCoberturaAtivaPagandoPremio},
    {id: 'PAGAMENTO ÚNICO', idConversao: HARDCODE.idStatusCoberturaAtivaPremioPago},
    {id: 'BENEFICIO PROLONGADO', idConversao: HARDCODE.idStatusCoberturaAtivaPremioPago},
    //{id: 'EXPIRED', idConversao: HARDCODE.idStatusCoberturaExpirada},
    //{id: 'CONVERTED', idConversao: HARDCODE.idStatusCoberturaConvertida},
    {id: 'RESGATE', idConversao: HARDCODE.idStatusCoberturaResgatada},
    {id: 'LIQUIDAÇÃO ESPECIAL BENEFÍCIO', idConversao: HARDCODE.idStatusCoberturaResgatada}, // 04/2026
    {id: 'SALDAMENTO', idConversao: HARDCODE.idStatusCoberturaSaldada},
    {id: 'DESISTÊNCIA', idConversao: HARDCODE.idStatusCoberturaCancelada},
    {id: 'INADIMPLÊNCIA', idConversao: HARDCODE.idStatusCoberturaCancelada},
    {id: 'CANCELADO PELA REGULAÇÃO', idConversao: HARDCODE.idStatusCoberturaCancelada},
    {id: 'CANCELADO POR DEPENDÊNCIA', idConversao: HARDCODE.idStatusCoberturaCancelada}, // NOVO5
    {id: 'ÓBITO', idConversao: HARDCODE.idStatusCoberturaSinistroEmAnalise}, // 03/2026
    {id: 'PECÚLIO', idConversao: HARDCODE.idStatusCoberturaBeneficioPago},
    //{id: 'REJECTED', idConversao: HARDCODE.idStatusCoberturaRejeitada},
    //{id: 'REPLACED', idConversao: HARDCODE.idStatusCoberturaSubstituida},
    {id: 'CONTRATO ANULADO', idConversao: HARDCODE.idStatusCoberturaAnulada},
    {id: 'DOENÇAS GRAVES - B21', idConversao: HARDCODE.idStatusCoberturaAtivaPagandoPremio}, // 10/2026
]



const statusApoliceMetLife = [
    {id: 'A', idConversao: HARDCODE.idStatusApoliceAtiva},
    {id: 'C', idConversao: HARDCODE.idStatusApoliceCancelada},
]

const statusPropostaMetLife = [
    {id: 'AGUARDANDO ENVIO DAS INFORMAÇÕES COMPLEMENTARES', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'AGUARDANDO CARTA ADENDO ASSINADA', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'AGUARDANDO ANÁLISE TÉCNICA', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'PROPOSTA EM REVISÃO TÉCNICA', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'AGUARDANDO CONFERÊNCIA DE TAXA', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'INFORMAÇÕES ADICIONAIS DISPONIBILIZADAS', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'AGUARDANDO REALIZAÇÃO/ENVIO DE EXAMES DE PERFIL (SAMPLEMED)', idConversao: HARDCODE.idStatusPropostaPendente},
    {id: 'CARTA ADENDO RECEBIDA - AGUARDANDO ANÁLISE', idConversao: HARDCODE.idStatusPropostaEmAnalise},
    {id: 'PROPOSTA ACEITA – EM PROCESSO DE IMPLANTAÇÃO', idConversao: HARDCODE.idStatusPropostaEmAnalise},
    {id: 'EM ANÁLISE', idConversao: HARDCODE.idStatusPropostaEmAnalise},
    {id: 'PROPOSTA IMPLANTADA', idConversao: HARDCODE.idStatusPropostaImplantada},
    //{id: '', idConversao: HARDCODE.idStatusPropostaPaga},
    {id: 'CANCELADO PELO USUÁRIO', idConversao: HARDCODE.idStatusPropostaCancelada},
    {id: 'PROPOSTA ENCERRADA A PEDIDO DO CLIENTE', idConversao: HARDCODE.idStatusPropostaCancelada},
    {id: 'PROPOSTA RECUSADA', idConversao: HARDCODE.idStatusPropostaRecusada},
    {id: 'PROPOSTA RECUSADA AUTOMATICAMENTE', idConversao: HARDCODE.idStatusPropostaRecusada},
    {id: 'PROPOSTA RECUSADA TEMPORARIAMENTE', idConversao: HARDCODE.idStatusPropostaRecusada},
]

const tipoCoberturaSeguroVidaMetLife = [
    {id: 'VIDA SEGURA MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//NOVO
    {id: 'MORTE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//NOVO
    {id: 'TEMPORÁRIA POR MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//07/2026 Cotação
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},//novo
    {id: 'MORTE COM CAPITAL DECRESCENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente},
    {id: 'INVALIDEZ PERMANENTE POR DOENÇA FUNCIONAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'INVALIDEZ ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteParcial},
    {id: 'INVALIDEZ TOTAL OU PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//NOVO5
    {id: 'DOENCAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},//NOVO5
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'FRATURA ÓSSEA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaQuebraOssos},//NOVO
    {id: 'DIÁRIA POR INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'DIARIA DE INTERNACAO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},//NOVO5
    {id: 'DIÁRIA POR INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
    {id: 'DIARIA POR INCAPACIDADE TEMPORARIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},//NOVO5
    {id: 'RENDA POR INCAPACIDADE TEMP. COM DOENÇA CRÔNICA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}, //Novo
    {id: 'FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'FRATURA OSSEA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaQuebraOssos},//NOVO5
    {id: 'CIRURGIAS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},//NOVO5
    {id: 'VT 20 - MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//NOVO5
    {id: 'VT 10 - MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//NOVO5
    {id: 'VT 5 - MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//NOVO5
    {id: 'SINGULAR 5 - MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//NOVO5
    {id: 'VIDA TOTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
]



const tipoCoberturaSeguroVidaOmint = [
    {id: 'MORTE – COBERTURA TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'MORTE - M', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'INVALIDEZ PERMANENTE TOTAL OU PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'INVALIDEZ PERMANENTE TOTAL OU PARCIAL MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'INVALIDEZ POR ACIDENTE TOTAL/PARCIAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'INVALIDEZ PERMANENTE POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteParcial},
    {id: 'INVALIDEZ FUNCIONAL PERMANENTE TOTAL DOR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'INVALIDEZ FUNCIONAL PERMANENTE TOTAL POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'IPA MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'DOENÇAS GRAVES AMPLIADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DIÁRIA DE INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'FUNERAL INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'JAZIGO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'PROTEÇÃO CIRÚRGICA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia}, //novo
    {id: 'QUEBRA DE OSSOS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaQuebraOssos}, //novo
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT}
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
]



const statusApolicePrudential = [
    {id: 'ATIVA', idConversao: HARDCODE.idStatusApoliceAtiva},
    {id: 'VIGENTE', idConversao: HARDCODE.idStatusApoliceAtiva},//Excel
    {id: 'CANCELADA', idConversao: HARDCODE.idStatusApoliceCancelada},
    {id: 'CANCELADO', idConversao: HARDCODE.idStatusApoliceCancelada},//Excel
    {id: 'REJEITADA', idConversao: HARDCODE.idStatusApoliceRejeitada},//Nova
    {id: 'CONVERTIDA', idConversao: HARDCODE.idStatusApoliceConvertida},//Nova
    {id: 'SUBSTITUÍDA', idConversao: HARDCODE.idStatusApoliceSubstituida},//Nova
    {id: 'ANULADA', idConversao: HARDCODE.idStatusApoliceAnulada},//Nova
    {id: 'COBERTURA TERMINADA', idConversao: HARDCODE.idStatusApoliceTerminada},//Nova
    {id: 'SINISTRADA', idConversao: HARDCODE.idStatusApoliceSinistrada},////Nova
    {id: 'ANALISANDO SINISTRO', idConversao: HARDCODE.idStatusApoliceSinistroEmAnalise},//MAIS RECENTE
    {id: 'SINISTRO NEGADO', idConversao: HARDCODE.idStatusApoliceSinistroNegado},//06/2026
]

const tipoCoberturaSeguroVidaPrudential = [
    {id: 'VIDA INTEIRA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'WHOLE LIFE SPECIAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},//MAIS RECENTE
    {id: 'VIDA E SAUDE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},////novo
    {id: 'TEMPORÁRIO DECRESCENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente},
    {id: 'TEMPORARIO DECRESCENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente},//novo*
    {id: 'TEMPORARI0 DECRESCENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente},//novo*
    {id: 'TEMPORÁRIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'TEMPORARIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//novo
    {id: 'RENDA FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaRendaFamiliar},
    {id: 'DOTAL MISTO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDotalMisto},
    {id: 'DOTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDotal},
    {id: 'MORTE ACID.', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'INVALIDEZ PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteParcial},
    {id: 'INVALIDEZ PARCIAL ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteParcial},
    {id: 'INVALIDEZ ACIDENTAL POR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteParcial},//novo
    {id: 'INVALIDEZ ACIDENTAL 5', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteParcial},//Novo
    {id: 'INVALIDEZ TOTAL E PARCIAL POR  ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'INVALIDEZ TOTAL E PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'INVALIDEZ TOTAL/PARCIAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},//NOVO NOVO
    {id: 'PERDA DA AUTONOMIA PESSOAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
    {id: 'PERDA AUTONOMIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},//nobo
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DOENCAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},//novo
    {id: 'DOENÇAS MODULAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DOENCAS MODULAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},//novo*
    {id: 'DOENÇAS PLUS ASSIST', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},//super novo
    {id: 'DOENCAS PLUS ASSIST', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},//super novo
    {id: 'CIRURGIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    {id: 'QUEBRA DE OSSOS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaQuebraOssos},
    {id: 'RENDA HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'ASSISTÊNCIA FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'ASSISTENCIA FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//novo*
    {id: 'ASSISTENCIA FUNERAL POR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//Novo
    {id: 'ASSIST FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'AF FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//06/2026
    {id: 'AF INDIVIDUAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},//06/2026
    {id: 'A_RPU SEGURO COM VALOR SALDADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},
    {id: 'B_RPU SEGURO COM VALOR SALDADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},
    {id: 'C_RPU SEGURO COM VALOR SALDADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},
    {id: '**RPU SEGURO COM VALOR SALDADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},
    {id: 'F_RPU SEGURO COM VALOR SALDADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},
    {id: 'RPU - VALOR SALDADO (A_RPU)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},//Excel
    {id: 'RPU - VALOR SALDADO (B_RPU)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},//Excel
    {id: 'RPU - VALOR SALDADO (C_RPU)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},//Excel
    {id: 'RPU - VALOR SALDADO (F_RPU)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},//Excel
    {id: 'RPU - VALOR SALDADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaValorSaldado},//Excel
    {id: 'B_ETI TEMPORÁRIO COM BENEFÍCIO PROLONGADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaBeneficioProlongado},
    {id: 'B_ETI TEMPORARIO COM BENEFICIO PROLONGADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaBeneficioProlongado},//novo*
    {id: 'C_ETI TEMPORÁRIO COM BENEFÍCIO PROLONGADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaBeneficioProlongado},
    {id: 'C_ETI TEMPORARIO COM BENEFICIO PROLONGADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaBeneficioProlongado},//novo*
    {id: 'ETI - BENEFÍCIO PROLONGADO (C_ETI)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaBeneficioProlongado},//Excel
    {id: 'ETI - BENEFÍCIO PROLONGADO (F_ETI)', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaBeneficioProlongado},//Excel
    {id: 'ETI - BENEFÍCIO PROLONGADO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaBeneficioProlongado},//Excel
]

const statusCoberturaPrudential = [
    {id: 'PREMIUM PAYING', idConversao: HARDCODE.idStatusCoberturaAtivaPagandoPremio, linhas: 2},
    {id: 'PREMIUM', idConversao: HARDCODE.idStatusCoberturaAtivaPagandoPremio, linhas: 3},
    {id: 'PAID-UP LIFE', idConversao: HARDCODE.idStatusCoberturaAtivaPremioPago, linhas: 1},
    {id: 'PAID-UP ANNUIT', idConversao: HARDCODE.idStatusCoberturaAtivaPremioPago, linhas: 1},
    {id: 'ATIVA - PRÊMIO DISPENSADO (WAIVER)', idConversao: HARDCODE.idStatusCoberturaAtivaPremioDispensado, linhas: 1},
    {id: 'EXPIRED', idConversao: HARDCODE.idStatusCoberturaExpirada, linhas: 1},
    {id: 'CONVERTED', idConversao: HARDCODE.idStatusCoberturaConvertida, linhas: 1},
    {id: 'SURRENDERED', idConversao: HARDCODE.idStatusCoberturaResgatada, linhas: 1},
    {id: 'CANCELADA COM VALORES PAGOS AO CLIENTE - VALOR DE RESGATE/PROVISÃO MATEMÁTICA', idConversao: HARDCODE.idStatusCoberturaResgatada, linhas: 1},//MAIS RECENTE
    {id: 'LAPSED', idConversao: HARDCODE.idStatusCoberturaCancelada, linhas: 1},
    {id: 'DEATH', idConversao: HARDCODE.idStatusCoberturaSinistroEmAnalise, linhas: 1},
    {id: 'BENEFÍCIO EM ANÁLISE', idConversao: HARDCODE.idStatusCoberturaSinistroEmAnalise, linhas: 1},//MAIS RECENTE
    {id: 'APÓLICE COM SINISTRO', idConversao: HARDCODE.idStatusCoberturaSinistroEmAnalise, linhas: 1},//MAIS RECENTE MAIS RECENTE
    {id: 'BENEFÍCIO PAGO', idConversao: HARDCODE.idStatusCoberturaBeneficioPago, linhas: 1},
    {id: 'SINISTRO NEGADO', idConversao: HARDCODE.idStatusCoberturaSinistroNegado, linhas: 1},//06/2026
    {id: 'MATURED', idConversao: HARDCODE.idStatusCoberturaBeneficioPago, linhas: 1},//Novo
    {id: 'REJECTED', idConversao: HARDCODE.idStatusCoberturaRejeitada, linhas: 1},//Novo
    {id: 'REPLACED', idConversao: HARDCODE.idStatusCoberturaSubstituida, linhas: 1},//Novo
    {id: 'NOT TAKEN', idConversao: HARDCODE.idStatusCoberturaAnulada, linhas: 1},//Novo
    {id: 'PAGO', idConversao: HARDCODE.idStatusCoberturaAtivaPremioPago, linhas: 1},//Novo
]



const tipoCoberturaSeguroVidaPortoSeguro = [
    {id: 'MORTE NATURAL OU ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    //{id: 'MORTE - M', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'INVALIDEZ PERMANENTE TOTAL OU PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'ANTECIPAÇÃO ESPECIAL POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
    //{id: 'INVALIDEZ PERMANENTE POR ACIDENTE MAJORADA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteParcial},
    //{id: 'INVALIDEZ FUNCIONAL PERMANENTE TOTAL DOR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    //{id: 'DIÁRIA DE INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    {id: 'DIÁRIA POR INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
    {id: 'ASSISTÊNCIA FUNERAL - TITULAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'ASSISTÊNCIA FUNERAL - FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'FUNERAL EXTENSIVO AOS PAIS', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    //{id: 'FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    {id: 'MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},//06/2026
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},
]



//const statusApoliceSantander = [
//    {id: 'EMITIDA', idConversao: HARDCODE.idStatusApoliceAtiva},
//    {id: 'CANCELADA', idConversao: HARDCODE.idStatusApoliceCancelada},/
//]

const tipoCoberturaSeguroVidaSantander = [
    //{id: 'MORTE QUALQUER CAUSA VITALÍCIO', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'INDENIZAÇÃO ADICIONAL POR MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'AUXÍLIO FUNERAL FAMILIAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    //{id: 'DIÁRIA POR INTERNAÇÃO HOSPITALAR', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    //{id: 'DIÁRIA POR INCAPACIDADE TEMPORÁRIA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},
    {id: 'DOENÇA TERMINAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'INVALIDEZ PERM. TOTAL OU PARCIAL P/ ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    //{id: 'INVALIDEZ PERMANENTE TOTAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotal},
    //{id: 'INDENIZAÇÃO ESPECIAL DE INVALIDEZ POR DOENÇA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    {id: 'MORTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
]



const statusApoliceXP = [
    {id: 'ATIVA', idConversao: HARDCODE.idStatusApoliceAtiva},
    //{id: 'VIGENTE', idConversao: HARDCODE.idStatusApoliceAtiva},//Excel
    {id: 'CANCELADA', idConversao: HARDCODE.idStatusApoliceCancelada},
    //{id: 'CANCELADO', idConversao: HARDCODE.idStatusApoliceCancelada},//Excel
    //{id: 'REJEITADA', idConversao: HARDCODE.idStatusApoliceRejeitada},//Nova
    //{id: 'CONVERTIDA', idConversao: HARDCODE.idStatusApoliceConvertida},//Nova
    //{id: 'SUBSTITUÍDA', idConversao: HARDCODE.idStatusApoliceSubstituida},//Nova
    //{id: 'ANULADA', idConversao: HARDCODE.idStatusApoliceAnulada},//Nova
    //{id: 'COBERTURA TERMINADA', idConversao: HARDCODE.idStatusApoliceTerminada},//Nova
    //{id: 'SINISTRADA', idConversao: HARDCODE.idStatusApoliceSinistrada},////Nova
    //{id: 'ANALISANDO SINISTRO', idConversao: HARDCODE.idStatusApoliceSinistroEmAnalise},//MAIS RECENTE
    {id: 'SUSPENSA', idConversao: HARDCODE.idStatusApoliceSuspensa},
]

const tipoCoberturaSeguroVidaXP = [
    {id: 'MORTE QUALQUER CAUSA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'MORTE DECRESCENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente}, // 10/2026
    {id: 'XP TODA VIDA', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira},
    {id: 'DOENÇA TERMINAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    {id: 'DOENÇAS GRAVES', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario},
    {id: 'MORTE ACIDENTAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental},
    {id: 'INV. PERM. TOTAL OU PARCIAL POR ACIDENTE', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial},
    {id: 'AUXÍLIO FUNERAL', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPermanentePorDoenca},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDITA},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezFuncionalPorDoenca},
    //{id: 'x', tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIT},
]

const statusCoberturaXP = [
    {id: 'ATIVA', idConversao: HARDCODE.idStatusCoberturaAtivaPagandoPremio},
    {id: 'CANCELADA', idConversao: HARDCODE.idStatusCoberturaCancelada},
    {id: 'SUSPENSA', idConversao: HARDCODE.idStatusCoberturaSuspensa},
]

const tipoRecursoFinanceiroXP = [
    {id: 'PÓS FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPosFixado},
    {id: 'INFLAÇÃO', idConversao: HARDCODE.idTipoRecursoFinanceiroInflacao},
    {id: 'PRÉ FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPreFixado},
    {id: 'FUNDOS LISTADOS', idConversao: HARDCODE.idTipoRecursoFinanceiroFundosListados}, // novo
    {id: 'MULTIMERCADO', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
    {id: 'ALTERNATIVO', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado}, // novo
    {id: 'RENDA VARIÁVEL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
    {id: 'RENDA VARIÁVEL BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel}, // novo
    {id: 'RENDA VARIÁVEL GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel}, // novo*
    {id: 'RENDA FIXA', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa}, // novo**?
    {id: 'RENDA FIXA BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa}, // novo**?
    {id: 'RENDA FIXA GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa}, // novo**
    {id: 'INTERNACIONAL', idConversao: HARDCODE.idTipoRecursoFinanceiroInternacional},
]



const instituicaoFinanceiraList = [
    {
        id: 10,
        descricao: 'Alfa',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 10,
    },
    {
        id: 11,
        descricao: 'Allianz',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'AGRADECEMOS POR ESCOLHER A ALLIANZ! ESTA É A APÓLICE DO SEU SEGURO DE VIDA.',
                        'Nº Apólice:',
                        'Seguro você pode entrar em contato com a Ouvidoria Allianz. Acesse o site',
                        'CAPITAL PRÊMIO ANUAL',
                        //'Os beneficiários deste seguro são herdeiros legais. A alteração do beneficiário pode ser realizada',
                    ],
                rotinaIntegracao: importaApoliceAllianz,
                //statusApolice: statusApoliceAllianz,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaAllianz,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 4,
                chaveIntegracao:
                    [
                        'CÓDIGO INTERNO',
                        'RAMO',
                        'APÓLICE SUSEP',
                        'APÓLICE',
                        'ENDOSSO',
                        'RECIBO',
                        'CORRETOR',
                        'DATA MOVIMENTO',
                        'PARCELA',
                        'NOME SEGURADO',
                        'PRÊMIO LÍQUIDO',
                        'COMISSÃO',
                        '% COMISSÃO',
                        'COMISSÃO ANTECIPADA',
                    ],
                rotinaIntegracao: importaListaComissoesAllianz,
            },
        ],
        ordem: 11,
    },
    {
        id: 12, // HARDCODE.idInstituicaoFinanceiraAdemicon
        descricao: 'Ademicon',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosAdemiconConsorcioLogo,
        //svgConsorcioLogoMl: '25', //'8',
        corretoraValores: 'N',
        seguradora: 'N',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoConsorcio,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoConsorcio,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'CONTRATO POR ADESÃO AO GRUPO DE CONSÓRCIO Nº', 
                        'Propõe a ADEMICON ADMINISTRADORA CONSORCIOS S/A, sua admissão no consórcio, no plano caracterizado neste contrato, para adquirir com o respectivo',
                        'Diante do aqui pactuado, ficam expressamente revogados todos os Artigos do citado Contrato de Participação em Grupo de Consórcio para Aquisição',
                        'Construção de Bem Imóvel, que conflitam direta ou indiretamente com condições estabelecidas neste aditivo.',
                    ],
                rotinaIntegracao: importaConsorcioBensImoveisAdemicon,
            },
        ],
        ordem: 5,
    },
    {
        id: 13, // HARDCODE.idInstituicaoFinanceiraAncora
        descricao: 'Âncora',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosAncoraConsorcioLogo,
        //svgConsorcioLogoMl: '22',
        corretoraValores: 'N',
        seguradora: 'N',
        ordem: 13,
    },
    {
        id: 15,
        descricao: 'Azos',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Apólice de seguro',
                        'EXCELSIOR AZOS - PESSOAS INDIVIDUAL',
                        'Os prêmios apresentados na tabela acima indicam o prêmio de cada',
                        'O Capital Segurado será atualizado anualmente pelo IPCA/IBGE, conforme previsto nas',
                        'A COMPANHIA EXCELSIOR DE SEGUROS, a seguir denominada Seguradora, emite',
                        'Comprometida com os padrões de ética e integridade no atendimento a seus clientes,',
                    ],
                rotinaIntegracao: importaApoliceAzos,
                statusApolice: statusApoliceAzos,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaAzos,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceNovoLayout,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'apólice de seguro',
                        'Excelsior Azos - Pessoas Individual',
                        'Os prêmios apresentados na tabela acima indicam o prêmio de cada',
                        'O Capital Segurado será atualizado anualmente pelo IPCA/IBGE, conforme previsto nas',
                        'A COMPANHIA EXCELSIOR DE SEGUROS, a seguir denominada Seguradora, emite',
                        'Comprometida com os padrões de ética e integridade no atendimento', // a seus clientes,',
                    ],
                rotinaIntegracao: importaApoliceAzosNovoLayout,
                statusApolice: statusApoliceAzos,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaAzos,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacao,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    'razao_social',
                    'email_corretor',
                    'cpf_cnpj_corretor',
                    'plataforma',
                    'data_entrada_plataforma',
                    'data_saida_plataforma',
                    'numero_da_proposta',
                    'id_proposta',
                    'link_proposta',
                    'status_proposta',
                    'numero_da_apolice',
                    'id_apolice',
                    'link_apolice',
                    'status_apolice',
                    'valor_total',
                    'valor_anualizado',
                    'frequencia_pagamento',
                    'iof_total',
                    'comissao',
                    'nome_cliente',
                    'cpf_cliente',
                    'email_cliente',
                    'data_proposta',
                    'data_analise',
                    'inicio_vigencia_apolice',
                    'data_emissao_fatura',
                    'data_vencimento_fatura',
                    'link_fatura',
                    'data_pagamento',
                    'status_ultimo_pagamento',
                    'metodo_pagamento',
                    'tipo_acesso',
                    'id_broker',
                    'id_grupo',
                    'take_rate',
                    'data_cancelamento',
                    'mes_analise',
                    'ano_analise',
                ],
                rotinaIntegracao: importaListaApolicesAzosImplantacao,
                statusApolice: statusApoliceAzos,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaAzos,
                //statusCobertura: statusCoberturaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacaoSemAgente,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    'Nome do cliente',
                    'CPF do cliente',
                    'Telefone do cliente',
                    'Nome do responsável',
                    'Telefone do responsável',
                    'Email do responsável',
                    'ID da proposta',
                    'ID da apólice',
                    'Número da apólice',
                    'PDF da apólice',
                    'Coberturas',
                    'Premio',
                    'Data de emissão da apólice', // NOVO
                    'Data Início da vigência da apólice',
                    'Status da apólice (ativo, cancelado, em atraso)',
                    'Nº da Proposta de Endosso',
                    'Data de vencimento da fatura',
                    'link da fatura',
                    'Forma de pagamento',
                    'Mês em aberto',
                    'Número de faturas em aberto',
                ],
                rotinaIntegracao: importaListaApolicesAzosImplantacaoSemAgente,
                statusApolice: statusApoliceAzos,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaAzos,
                //statusCobertura: statusCoberturaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaCobrancas,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCobranca,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'razao_social',
                        'cpf_cnpj_corretor',
                        'email',
                        'plataforma',
                        'data_entrada_plataforma',
                        'data_saida_plataforma',
                        'numero_da_proposta',
                        'id_proposta',
                        'id_fatura',
                        'numero_da_apolice',
                        'link_apolice',
                        'link_proposta',
                        'valor_total',
                        'frequencia_pagamento',
                        'iof_total',
                        'comissao',
                        'take_rate',
                        'nome_cliente',
                        'cpf',
                        'data_proposta',
                        'status_do_pagamento',
                        'data_do_pagamento',
                        'data_vencimento_fatura',
                        'link_fatura',
                        'inicio_vigencia_apolice',
                        'data_emissao_fatura',
                        'metodo_pagamento',
                        'tipo_acesso',
                        'parcela_fatura',
                        'id_apolice',
                        'data_analise',
                        'premio_apolice',
                    ],
                rotinaIntegracao: importaListaCobrancasAzos,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 4,
                chaveIntegracao:
                    [
                        'Nome do Segurado',
                        'CPF do Segurado',
                        'ID da Apólice',
                        'Nº da Apólice',
                        'Coberturas',
                        'Mês de Competência',
                        'Parcela',
                        'Pagamento Segurado',
                        'Pagamento Comissão',
                        'Valor da Fatura',
                        'Comissão Bruta',
                        'Responsável pela Venda',
                        'Nº da Proposta de Endosso',
                    ],
                rotinaIntegracao: importaListaComissoesAzos,
            },
        ],
        ordem: 15,
    },
    {
        id: 17, // HARDCODE.idInstituicaoFinanceiraBancorbras
        descricao: 'Bancorbrás',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        SvgConsorcioLogo: SvgImageParceirosBancorbrasConsorcioLogo,
        //svgConsorcioLogoMl: '22',
        primeirasParcelasList: [
            {id: 5, descricao: '5 parcelas'},
        ],
        corretoraValores: 'N',
        seguradora: 'N',
        ordem: 17,
    },
    {
        id: 20,
        descricao: 'BB Seguros',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 20,
    },
    {
        id: 30, // HARDCODE.idInstituicaoFinanceiraBradesco
        descricao: 'Bradesco',
        SvgLogo: SvgImageParceirosBradescoLogo,
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        SvgConsorcioLogo: SvgImageParceirosBradescoConsorcioLogo,
        //svgConsorcioLogoMl: '25', //''0',
        //primeirasParcelasList: [
        //    {id: 6, descricao: '6 parcelas'},
        //],
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceVidaInteiraVivaMais,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Agradecemos por escolher o Seguro SEGURO BRADESCO PARA VIDA INTEIRA',
                        'BRADESCO VIDA E PREVIDENCIA S.A.',
                        'CNPJ 51.990.695/0001-37',
                        'da vigência da Apólice, salvo as hipóteses de cancelamento previstas nas Condições Gerais deste',
                        'ESTA PARTE NÃO INTEGRA A APÓLICE E/OU CERTIFICADO DE SEGURO',
                    ],
                rotinaIntegracao: importaApoliceBradescoVidaInteiraVivaMais,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaBradesco,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceVidaInteiraVivaMais,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Agradecemos por escolher o Seguro VIDA INTEIRA BRADESCO',
                        'BRADESCO VIDA E PREVIDENCIA S.A.',
                        'CNPJ 51.990.695/0001-37',
                        'da vigência da Apólice, salvo as hipóteses de cancelamento previstas nas Condições Gerais deste',
                        'ESTA PARTE NÃO INTEGRA A APÓLICE E/OU CERTIFICADO DE SEGURO',
                    ],
                rotinaIntegracao: importaApoliceBradescoVidaInteiraVivaMais,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaBradesco,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceVidaInteiraVivaMais,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Agradecemos por escolher o Seguro SEGURO VIVA MAIS BRADESCO RESGATAVEL',
                        'BRADESCO VIDA E PREVIDENCIA S.A.',
                        'CNPJ 51.990.695/0001-37',
                        'da vigência da Apólice, salvo as hipóteses de cancelamento previstas nas Condições Gerais deste',
                        'ESTA PARTE NÃO INTEGRA A APÓLICE E/OU CERTIFICADO DE SEGURO',
                    ],
                rotinaIntegracao: importaApoliceBradescoVidaInteiraVivaMais,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaBradesco,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceVidaInteiraVivaMais,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Agradecemos por escolher o Seguro VIDA RESGATAVEL BRADESCO',
                        'BRADESCO VIDA E PREVIDENCIA S.A.',
                        'CNPJ 51.990.695/0001-37',
                        'da vigência da Apólice, salvo as hipóteses de cancelamento previstas nas Condições Gerais deste',
                        'ESTA PARTE NÃO INTEGRA A APÓLICE E/OU CERTIFICADO DE SEGURO',
                    ],
                rotinaIntegracao: importaApoliceBradescoVidaInteiraVivaMais,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaBradesco,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceMultiPlanoVivaMais,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Agradecemos por escolher o Seguro  MULTIPLANO GERACAO 3 BRADESCO !  A partir',
                        'BRADESCO VIDA E PREVIDENCIA S.A.',
                        'CNPJ 51.990.695/0001-37',
                        'Apólice, salvo as hipóteses de cancelamento previstas nas Condições Gerais deste Seguro.',
                        'ESTA PARTE NÃO INTEGRA A APÓLICE E/OU CERTIFICADO DE SEGURO',
                    ],
                rotinaIntegracao: importaApoliceBradescoMultiPlanoVivaMais,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaBradesco,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceMultiPlanoVivaMais,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Agradecemos por escolher o Seguro VIVA MAIS BRADESCO - SEGURO RESGATAVEL !',
                        'BRADESCO VIDA E PREVIDENCIA S.A.',
                        'CNPJ 51.990.695/0001-37',
                        'Apólice, salvo as hipóteses de cancelamento previstas nas Condições Gerais deste Seguro.',
                        'ESTA PARTE NÃO INTEGRA A APÓLICE E/OU CERTIFICADO DE SEGURO',
                    ],
                rotinaIntegracao: importaApoliceBradescoMultiPlanoVivaMais,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaBradesco,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 1,
                chaveIntegracao:
                    [
                        '-',
                        'NÚMERO DA FATURA',
                        'SUCURSAL',
                        'DADOS BANCÁRIOS',
                        'DATA LANÇ',
                        'LANÇ',
                        'CERTIFICADO',
                        'PROPOSTA',
                        'Nº CONTRATO',
                        'FORM DE VENDA',
                        'APÓLICE / SUBFATURA',
                        'ENDOSSO',
                        'RAMO',
                        'BENEF',
                        'NOME DO PARTICIPANTE',
                        'SEGURADO',
                        'PARCELA',
                        'CONTRIB',
                        'VL_PRÊMIO',
                        'VL_CONTRIB (R$)',
                        '%',
                        'VALOR',
                        'CPF/CNPJ CLIENTE',
                        'MATRICULA',
                        'DATA EMISSÃO',
                        'DATA DE VENDA',
                        'PREFIXO',
                        'ITEM APÓLICE',
                        'PRODUTO',
                        'PLANO',
                        'TAXA GESTÃO',
                        'TAXA DE CARREGAMENTO',
                        'BANDEIRA DO CARTÃO',
                        'TIPO DO CARTÃO',
                        'FASE/COMISSÃO',
                        'TIPO DE REMUNERAÇÃO',
                        'RECURSO FINANCEIRO',
                        'NÚMERO DO CHASSI',
                        'NÚMERO DA LICENÇA',
                        'SERIE PROPOSTA',
                    ],
                rotinaIntegracao: importaListaComissoesBradesco,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 1,
                chaveIntegracao:
                    [
                        '-',
                        'NÚMERO DA FATURA',
                        'SUCURSAL',
                        'DADOS BANCÁRIOS',
                        'DATA LANÇ',
                        'LANÇ',
                        'CERTIFICADO',
                        'PROPOSTA',
                        'Nº CONTRATO',
                        'FORM DE VENDA',
                        'APÓLICE / SUBFATURA',
                        'ENDOSSO',
                        'RAMO',
                        'BENEF',
                        'NOME DO PARTICIPANTE',
                        'SEGURADO',
                        'PARCELA',
                        'CONTRIB',
                        'VL_PRÊMIO',
                        'VL_CONTRIB (R$)',
                        '%',
                        'VALOR',
                        'CPF/CNPJ CLIENTE',
                        'MATRICULA',
                        'DATA EMISSÃO',
                        'DATA DE VENDA',
                        'PREFIXO',
                        'ITEM APÓLICE',
                        'PRODUTO',
                        'PLANO',
                        'TAXA GESTÃO',
                        'TAXA DE CARREGAMENTO',
                        'BANDEIRA DO CARTÃO',
                        'TIPO DO CARTÃO',
                        'FASE/COMISSÃO',
                        'TIPO DE REMUNERAÇÃO',
                        'RECURSO FINANCEIRO',
                        'NÚMERO DO CHASSI',
                        'NÚMERO DA LICENÇA',
                        'SERIE PROPOSTA',
                        'TITULO',
                    ],
                rotinaIntegracao: importaListaComissoesBradesco,
            },
        ],
        integracaoAvulso: [
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Seguro Bradesco para',
                        'Vida Inteira',
                        'Seu Estudo Personalizado',
                        'Data da cotação:',
                        'Para obter maiores informações sobre como os seus dados pessoais são tratados pela Bradesco Vida e Previdência S.A., consulte a www.bradescoseguranca.com.br',
                    ],
                rotinaIntegracao: importaCotacaoBradescoTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Seguro Viva Mais',
                        'Bradesco Resgatável',
                        'Seu Estudo Personalizado',
                        'Data da cotação:',
                        'Para obter maiores informações sobre como os seus dados pessoais são tratados pela Bradesco Vida e Previdência S.A., consulte a www.bradescoseguranca.com.br',
                    ],
                rotinaIntegracao: importaCotacaoBradescoTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
        ],
        ordem: 30,
    },
    {
        id: 35, // HARDCODE.idInstituicaoFinanceiraBTG
        descricao: 'BTG PACTUAL',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'S',
        seguradora: 'N',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentosLayout2,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'investimentos e evolução de patrimônio',
                        //'Impostos Provisionados',
                        'Do seu portfólio em comparação com o índice de referência, são',
                        'Como retorno, o portfólio obteve:',
                        'Quanto disponibilidade, temos:',
                        'Relatório de Performance',
                        'O BTG Pactual não é responsável pela exatidão, integridade ou atualização',
                        'de que, em nenhuma hipótese, o BTG Pactual poderá ser responsabilizado',
                        'Mês 3 Meses 6 Meses Ano 12 Meses',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosBTGLayout2,
                tipoRecursoFinanceiro: tipoRecursoFinanceiroBTG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentos,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'investimentos e evolução de patrimônio',
                        //'Impostos Provisionados', //26/09/2026
                        'Do seu portfólio em comparação com o índice de referência, são',
                        'Como retorno, o portfólio obteve:',
                        'Quanto disponibilidade, temos:',
                        'Relatório de Performance',
                        'O BTG Pactual não é responsável pela exatidão, integridade ou atualização',
                        'de que, em nenhuma hipótese, o BTG Pactual', // poderá ser responsabilizado',
                        //'Mês 3 Meses 6 Meses Ano 12 Meses',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosBTG,
                tipoRecursoFinanceiro: tipoRecursoFinanceiroBTG,
            },
        ],
        ordem: 35,
    },
    {
        id: 40,
        descricao: 'Capemisa',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 40,
    },
    {
        id: 50,
        descricao: 'Caixa',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 50,
    },
    {
        id: 60,
        descricao: 'Centauro ON',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 60,
    },
    //{
    //    id: 65,
    //    descricao: 'Consórcio Magalu',
    //    administradoraConsorcio: 'S',
    //    administradoraConsorcioLinkCaptacaoLeads: 'N',
    //    corretoraValores: 'N',
    //    seguradora: 'N',
    //    ordem: 65,
    //},
    {
        id: 70,
        descricao: 'Chubb',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 70,
    },
    {
        id: 73, // HARDCODE.idInstituicaoFinanceiraCNP
        descricao: 'CNP',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosCNPConsorcioLogo,
        //svgConsorcioLogoMl: '22',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 73,
    },
    {
        id: 74, // HARDCODE.idInstituicaoFinanceiraEmbracon
        descricao: 'Embracon',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosEmbraconConsorcioLogo,
        //svgConsorcioLogoMl: '22',
        primeirasParcelasList: [
            {id: 1, descricao: '1 parcela'},
            {id: 2, descricao: '2 parcelas'},
            {id: 5, descricao: '5 parcelas'},
            {id: 8, descricao: '8 parcelas'},
            {id: 12, descricao: '12 parcelas'},
        ],
        corretoraValores: 'N',
        seguradora: 'N',
        ordem: 74,
    },
    {
        id: 75,
        descricao: 'Excelsior',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 75,
    },
    {
        id: 80,
        descricao: 'Generalli',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 80,
    },
    //{
    //    id: 85,
    //    descricao: 'HS Consórcios',
    //    administradoraConsorcio: 'S',
    //    administradoraConsorcioLinkCaptacaoLeads: 'N',
    //    corretoraValores: 'N',
    //    seguradora: 'N',
    //    ordem: 85,
    //},
    {
        id: 90, // view fintrackssch.vw_cliente_acesso_proposta 
        descricao: 'Icatu',
        SvgLogo: SvgImageParceirosIcatuLogo,
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoPropostaHorizonte,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Proposta de Contratação Seguro de Vida 3 vias - 1ª seguradora / 2ª corretor / 3ª proponente',
                        'Uma vez aprovada esta proposta pela Icatu Seguros S.A., declaro estar ciente e de acordo que:', 
                        'Estou ciente que a proposta nova de seguro, quando isoladamente ou cumulada com outros seguros ativos na Icatu, tiver capital segurado para a cobertura',
                    ],
                rotinaIntegracao: importaPropostaIcatuHorizonte,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoPropostaEssencial,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'pago será descontado da indenização. A Icatu Seguros S.A está autorizada a buscar novos subsídios para a análise no momento da aceitação ou', 
                        'ocorrência de sinistro. As informações contidas nesta proposta são completas e verdadeiras. Estou ciente de que qualquer omissão por mim contida',
                        'Estou ciente que a proposta nova de seguro, quando isoladamente ou cumulada com outros seguros ativos na Icatu, tiver capital segurado',
                        'concorda em receber este seguro não contributário. Declara, ainda, ter',
                    ],
                rotinaIntegracao: importaPropostaIcatuEssencial,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaPropostas,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoProposta,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "Cliente",
                        "Proposta",
                        "Premio Mensal",
                        "Premio Anual",
                        "Corretora Lider",
                        "Co Corretagem",
                        "Data da Transmissão",
                        "Data da Assinatura",
                        "Status Atual",
                        "Prazo Subscrição",
                        "Vencimento da 1ª Parcela",
                        "Modulo",
                    ],
                rotinaIntegracao: importaListaPropostasIcatu,
                statusProposta: [
                    {id: 'ACEITA, AGUARDANDO PAGAMENTO', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: false},
                    {id: 'ACEITA AGUARDANDO PAGAMENTO', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: false},
                    {id: 'ACEITA, AGUARDANDO RETORNO DO CARTÃO DE CREDITO', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: false},
                    {id: 'ACEITA, AGAURDANDO PAGAMENTO', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: false},
                    {id: 'ACEITO, AGUARDANDO PAGAMENTO', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: false},
                    {id: 'ACEITO, ENVIADO CARTA DE NOVAS CONDIÇÕES', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'ANALISE', idConversao: HARDCODE.idStatusPropostaEmAnalise, atualizaDataUltimaAlteracao: false},
                    {id: 'CANCELADA PELO CORRETOR', idConversao: HARDCODE.idStatusPropostaCancelada, atualizaDataUltimaAlteracao: false},
                    {id: 'CARTA ASSINADA E ENVIADA AO SETOR', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'CARTA DE NOVAS CONDIÇÕES ENVIADA', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'CLIENTE PPE', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: false},
                    {id: 'DESISTÊNCIA DO CLIENTE', idConversao: HARDCODE.idStatusPropostaCancelada, atualizaDataUltimaAlteracao: true},
                    {id: 'DOC COMPLEMENTAR ENVIADO', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'DOC. COMPLEMENTAR ENVIADO', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'ENVIADO AO SETOR', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'ENVIADO DOC COMPLEMENTAR', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'ENVIADO DOC. COMPLEMENTAR', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'IMPLANTADA', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: true},
                    {id: 'IMPLATADA', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: true},
                    {id: 'PENDENCIA', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'RECUSADA - PENDENCIA', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'RECUSADA A PEDIDO', idConversao: HARDCODE.idStatusPropostaCancelada, atualizaDataUltimaAlteracao: false},
                    {id: 'RECUSADA APOS 60 DIAS', idConversao: HARDCODE.idStatusPropostaCancelada, atualizaDataUltimaAlteracao: false},
                    {id: 'RECUSADA', idConversao: HARDCODE.idStatusPropostaRecusada, atualizaDataUltimaAlteracao: false},
                    {id: 'RECUSADO TEMPO DE PENDENCIA - PENDENCIA', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'RECUSADO', idConversao: HARDCODE.idStatusPropostaRecusada, atualizaDataUltimaAlteracao: false},
                    {id: 'RECUSA A PEDIDO', idConversao: HARDCODE.idStatusPropostaCancelada, atualizaDataUltimaAlteracao: false},
                    {id: 'RECUSA TEMPO DE PENDENCIA - ACEITO, ENVIADO CARTA DE NOVAS CONDIÇÕES', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'RECUSA TEMPO DE PENDENCIA - PENDENCIA', idConversao: HARDCODE.idStatusPropostaPendente, atualizaDataUltimaAlteracao: true},
                    {id: 'RECUSA', idConversao: HARDCODE.idStatusPropostaRecusada, atualizaDataUltimaAlteracao: false},
                    {id: 'REVERSÃO DA RECUSA - ACEITA, AGUARDANDO PAGAMENTO - CLIENTE VAI CADASTRAR O CARTÃO DE CREDITO ENVIADO LINK', idConversao: HARDCODE.idStatusPropostaImplantada, atualizaDataUltimaAlteracao: true},
                ],
                tipoPeriodicidadePagtoPremio: [
                    {id: 30, idConversao: HARDCODE.idTipoPeriodicidadeMensal},
                    {id: 180, idConversao: HARDCODE.idTipoPeriodicidadeSemestral},
                    {id: 365, idConversao: HARDCODE.idTipoPeriodicidadeAnual},
                ],
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceEssencialSuperAPVidaDigital,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'A ICATU SEGUROS S/A,',
                        'CNPJ 42.283.770/0001-39', //' certifica que',
                        //'é participante', => NOVO ESSENCIAL
                        'ESSENCIAL',
                        'CERTIFICADO INDIVIDUAL',
                        'DADOS DA APÓLICE',
                        'COBERTURAS E CAPITAIS SEGURADOS',
                        'Os valores de capital e prêmio serão atualizados anualmente pelo índice constante neste',
                    ],
                rotinaIntegracao: importaApoliceIcatuEssencialSuperAPVidaDigital,
                statusApolice: statusApoliceIcatu,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceEssencialSuperAPVidaDigital,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'A ICATU SEGUROS S/A,',
                        'CNPJ 42.283.770/0001-39 certifica que',
                        'é participante do SUPER AP',
                        'CERTIFICADO INDIVIDUAL',
                        'DADOS DA APÓLICE',
                        'COBERTURAS E CAPITAIS SEGURADOS',
                        'Os valores de capital e prêmio serão atualizados anualmente pelo índice constante neste',
                    ],
                rotinaIntegracao: importaApoliceIcatuEssencialSuperAPVidaDigital,
                statusApolice: statusApoliceIcatu,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceEssencialSuperAPVidaDigital,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'A ICATU SEGUROS S/A,',
                        'CNPJ 42.283.770/0001-39',//' certifica que',
                        'é participante do VIDA DIGITAL',
                        'CERTIFICADO INDIVIDUAL',
                        'DADOS DA APÓLICE',
                        'COBERTURAS E CAPITAIS SEGURADOS',
                        'Os valores de capital e prêmio serão atualizados anualmente pelo índice constante neste',
                    ],
                rotinaIntegracao: importaApoliceIcatuEssencialSuperAPVidaDigital,
                statusApolice: statusApoliceIcatu,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceEssencialSuperAPVidaDigital,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'A ICATU SEGUROS S/A,',
                        'CNPJ 42.283.770/0001-39',//' certifica que',
                        'é participante do PROFISSIONAL LIBERAL VI',
                        'CERTIFICADO INDIVIDUAL',
                        'DADOS DA APÓLICE',
                        'COBERTURAS E CAPITAIS SEGURADOS',
                        'Os valores de capital e prêmio serão atualizados anualmente pelo índice constante neste',
                    ],
                rotinaIntegracao: importaApoliceIcatuEssencialSuperAPVidaDigital,
                statusApolice: statusApoliceIcatu,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceHorizonte,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'CERTIFICADO INDIVIDUAL',
                        'A ICATU SEGUROS S/A,',
                        'CNPJ 42.283.770/0001-39',//' certifica que',
                        'participante',
                        'HORIZONTE',
                        'DADOS DA APÓLICE',
                        'COBERTURAS E CAPITAIS SEGURADOS',
                        'Os valores de capital e prêmio serão atualizados anualmente pelo índice constante neste',
                    ],
                rotinaIntegracao: importaApoliceIcatuHorizonte,
                statusApolice: statusApoliceIcatu,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Certificado do Seguro',
                        'https://clientes.icatuseguros.com.br/seguro-de-vida/dados-plano',
                        'Quer incluir ou alterar os beneficiários? Acesse a clientes.icatuseguros.c m.br/seguro-de-vida/da',
                        'Coberturas e Capitais Segurados',
                        'N° do apólice',
                        'As garantias deste seguro aplicam-se para eventos cobertos ocorridos em qualquer parte do globo terrestre.',
                    ],
                rotinaIntegracao: importaApoliceIcatu,
                statusApolice: statusApoliceIcatu,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacao,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    "Número do Estipulante",
                    "Nome do Estipulante",
                    "apolice_principal",
                    "numero_subestipulante",
                    "nome_subestipulante",
                    "numero_certificado",
                    "nome_segurado",
                    "data_nascimento",
                    "CPF",
                    "descricao_modulo",
                    "nome_conjuge",
                    "data_nascimento_conjuge",
                    "cpf_conjuge",
                    "inicio_vigencia",
                    "fim_vigencia",
                    "data_cancelamento",
                    "status_segurado",
                    "Motivo_Cancelamento",
                    "nm_forma_pagamento",
                    "banco",
                    "Agencia",
                    "conta_corrente",
                    "matricula_ih",
                    "matricula_funcional",
                    "numero_proposta",
                    "mqc_titular",
                    "mqc_conjuge",
                    "mqc_filhos",
                    "ma_titular",
                    "ma_conjuge",
                    "ma_filhos",
                    "ipa_titular",
                    "ipa_conjuge",
                    "iea_titular",
                    "iea_conjuge",
                    "ipd_titular",
                    "ipd_conjuge",
                    "ifpd_titular",
                    "ipta_titular",
                    "ipta_conjuge",
                    "rit_titular",
                    "dcmg_titular",
                    "dg_titular",
                    "adet_titular",
                    "auxdepesa_titular",
                    "tpo_titular",
                    "premio_titular",
                    "premio_conjuge",
                    "premio_filho",
                    "premio_saf",
                    "premio_total",
                    "dia_debito",
                    "data_ultimo_pagto",
                    "numero_sorte",
                    "serie_titulo_sorte",
                    "valor_titulo_sorte",
                    "bairro",
                    "cidade",
                    "uf",
                    "cep",
                    "Endereco",
                    "telefone",
                    "email",
                    "plano_senior",
                    "pagamento_carne",
                    "primeira_ato",
                    "periodicidade_pagto",
                    "qtd_parcelas_pagas",
                    "agencia_venda",
                    "unidade_atendimento",
                    "Sexo",
                    "dt_ultima_competencia_paga",
                    "capital_funcionarios",
                    "nr_funcionarios",
                    "capital_socios",
                    "nr_socios",
                    "dt_aceitacao_proposta",
                    "nm_corretor_lider",
                    "nm_corretor_segundo",
                    "nm_corretor_terceiro",
                    "cobertura_dg11",
                    "ipefpc_capital",
                    "ipefpc_premio",
                    "dt_ultima_competencia_gerada",
                    "nr_meses_vigencia_contr_cert",
                    "dt_inicio_contrato",
                    "dt_fim_contrato",
                    "ipam_titular",
                    "dmhap_titular",
                    "mqc_pai",
                    "mqc_mae",
                    "mqc_pais",
                ],
                rotinaIntegracao: importaListaApolicesIcatuImplantacao,
                statusApolice: statusApoliceIcatu,
                formaPagtoPremio: formaPagtoPremioIcatu,
                //tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
                //statusCobertura: statusCobertura???,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacaoSegundoLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    'nome_segurado',
                    'data_nascimento',
                    'CPF',
                    'descricao_modulo',
                    'inicio_vigencia',
                    'fim_vigencia',
                    'data_cancelamento',
                    'status_segurado',
                    'Motivo_Cancelamento',
                    'nm_forma_pagamento',
                    'numero_proposta',
                    'mqc_titular',
                    'ipa_titular',
                    'iea_titular',
                    'ifpd_titular',
                    'rit_titular',
                    'dcmg_titular',
                    'dg_titular',
                    'adet_titular',
                    'premio_titular',
                    'premio_saf',
                    'premio_total',
                    'dia_debito',
                    'data_ultimo_pagto',
                    'periodicidade_pagto',
                    'dt_ultima_competencia_paga',
                    'dt_aceitacao_proposta',
                    'nm_corretor_lider',
                    'nm_corretor_segundo',
                    'nm_corretor_terceiro',
                    'dt_ultima_competencia_gerada',
                    'ipam_titular',
                    'dmhap_titular'
                ],
                rotinaIntegracao: importaListaApolicesIcatuImplantacaoSegundoLayout,
                //tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaIcatu,
                statusApolice: statusApoliceIcatu,
                formaPagtoPremio: formaPagtoPremioIcatu,
                //statusCobertura: statusCobertura???,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 4,
                chaveIntegracao:
                    [
                        'Cliente',
                        'CPF',
                        'Lançamento',
                        'Produto',
                        'Processo',
                        'Data de pagamento',
                        'Certificado',
                        'Apólice',
                        'Proposta',
                        'Parcela',
                        'Vencimento',
                        'Data do cálculo',
                        'Valor base',
                        '%',
                        'Comissão',
                    ],
                rotinaIntegracao: importaListaComissoesIcatu,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoesSegundoLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 4,
                chaveIntegracao:
                    [
                        'Cliente',
                        'CPF',
                        'Lançamento',
                        'Produto',
                        'Processo',
                        'Data de pagamento',
                        'Certificado',
                        'Apólice',
                        'Proposta',
                        'Parcela',
                        'Vencimento',
                        'Data do cálculo',
                        'Valor base',
                        '%',
                        'Comissão',
                        'Cnpj',
                    ],
                rotinaIntegracao: importaListaComissoesIcatuSegundoLayout,
            },
        ],
        integracaoAvulso: [
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Seguro de Vida Horizonte ideal para você.',
                        'ENTENDA COMO FUNCIONA O SALDAMENTO',
                        'EVOLUÇÃO DO VALOR DE RESGATE – SIMULAÇÃO',
                        'Veja a evolução do valor de resgate para a(s) cobertura(s) escolhida(s):',
                    ],
                rotinaIntegracao: importaCotacaoIcatuTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Seguro de Vida Icatu, pensado para o seu momento de vida',
                        'Sobre a Icatu Sobre o Seguro de Vida Individual',
                        'Entenda como funciona o saldamento:',
                        'ANO VIGÊNCIA IDADE PAGAMENTO VALOR DO RESGATE VALOR SALDADO',
                        'Seguro de Vida administrado por Icatu Seguros S.A, inscrita no CNPJ/MF sob o nº 42.283.770/0001-39',
                    ],
                rotinaIntegracao: importaCotacaoIcatuTabelaEvolucaoValorResgateNovoLayout,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Seguro de Vida Icatu, pensado para o seu momento de vida',
                        'Sobre a Icatu Sobre o Seguro de Vida Individual',
                        'Entenda como funciona o saldamento:',
                        'ANO VIGÊNCIA IDADE PAGAMENTO VALOR SALDADO',
                        'Seguro de Vida administrado por Icatu Seguros S.A, inscrita no CNPJ/MF sob o nº 42.283.770/0001-39',
                    ],
                rotinaIntegracao: importaCotacaoIcatuTabelaEvolucaoValorResgateNovoLayout,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
        ],
        ordem: 90,
    },
    {
        id: 98, // HARDCODE.idInstituicaoFinanceiraIonItau
        descricao: 'Íon Itaú',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'S',
        seguradora: 'N',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentos,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Posição de Investimentos',
                        'Performance da carteira e principais índices de mercado',
                        'Detalhamento de Ativos',
                        'Os valores deste extrato são baseados nas informações disponíveis até as respectivas datas de referência informadas nos campos',
                        'Os rendimentos são apurados a partir da rentabilidade nominal, brutos de IR e IOF para carteira e ativos. Para ativos de Renda Variável',
                        'Os recursos dos planos PGBL e VGBL são aplicados em fundos de investimento, que não possuem garantia de rentabilidade, podendo, inclusive,',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosIonItau,
                tipoRecursoFinanceiro: [
                    {id: 'PÓS-FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPosFixado},
                    {id: 'INFLAÇÃO', idConversao: HARDCODE.idTipoRecursoFinanceiroInflacao},
                    {id: 'PREFIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPreFixado},
                    {id: 'FUNDO-DE-INVESTIMENTO', idConversao: HARDCODE.idTipoRecursoFinanceiroFundosListados},
                    {id: 'MULTIMERCADO', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
                    {id: 'ALTERNATIVOS-LÍQUIDOS', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
                    {id: 'RENDA-VARIÁVEL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
                    {id: 'CDB,-RENDA-FIXA-E-INV.-ESTRUTURADOS', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    {id: 'RENDA-FIXA-ATIVO', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    //{id: 'INTERNACIONAL', idConversao: HARDCODE.idTipoRecursoFinanceiroInternacional},
                    {id: 'POUPANÇA', idConversao: HARDCODE.idTipoRecursoFinanceiroPoupanca},
                    {id: 'PREVIDÊNCIA', idConversao: HARDCODE.idTipoRecursoFinanceiroPrevidenciaVGBL},
                ],
            },
        ],
        ordem: 98,
    },
    {
        id: 100, // HARDCODE.idInstituicaoFinanceiraItau
        descricao: 'Itaú',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosItauConsorcioLogo,
        //svgConsorcioLogoMl: '8',
        corretoraValores: 'S',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentos,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Performance da carteira e principais índices de mercado',
                        //'Com gross up: A rentabilidade aplica desconto à taxa dos ativos isentos de IR, permitindo comparação equivalente com os não isentos.', //saiu
                        //'Ativos Quantidade PU/Cotação (R$) Valor (R$) Alocação(%) ReferencialDia', //saiu
                        'relacionamento com o Itaú Private Bank. Dados relacionados à rentabilidade dos ativos adquiridos', //entrou
                        'Os valores deste extrato são baseados nas informações disponíveis até as respectivas datas de referência informadas nos campos "data da posição" e nos cards de rentabilidade',
                        'tributação regressiva definitiva. Consulte os regulamentos dos planos no site www.itau.com.br.',
                        'Se não ficar satisfeito com a solução apresentada, de posse do protocolo, contate a Ouvidoria: 0800 570 0011, em dias úteis, das 9h às 18h',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosItau,
                tipoRecursoFinanceiro: [
                    {id: 'PÓS-FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPosFixado},
                    {id: 'INFLAÇÃO', idConversao: HARDCODE.idTipoRecursoFinanceiroInflacao},
                    {id: 'PREFIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPreFixado},
                    //{id: 'FUNDOS LISTADOS', idConversao: HARDCODE.idTipoRecursoFinanceiroFundosListados},
                    {id: 'MULTIMERCADO', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
                    {id: 'ALTERNATIVOS', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado}, // suposição
                    {id: 'RENDA-VARIÁVEL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
                    //{id: 'RENDA VARIÁVEL BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
                    //{id: 'RENDA VARIÁVEL GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
                    {id: 'RENDA-FIXA-ATIVO', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    //{id: 'RENDA FIXA BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    //{id: 'RENDA FIXA GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    {id: 'INTERNACIONAL', idConversao: HARDCODE.idTipoRecursoFinanceiroInternacional}, // suposição
                ],
            },
        ],
        ordem: 100,
    },
    {
        id: 110,
        descricao: 'Liberty',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 110,
    },
    {
        id: 120,
        descricao: 'MAG',
        SvgLogo: SvgImageParceirosMAGLogo,
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoProposta,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'NÚMERO DA PROPOSTA:',
                        'A aceitação do seguro estará sujeita à análise do risco e a MAG Seguros tem o prazo', 
                        'Declaro, como Corretor nesta contratação, que, na forma da legislação vigente, dei cumprimento integral às disposições contidas na',
                        'Resolução CNSP nº 382/2020, inclusive quanto à prévia disponibilização ao proponente das informações previstas no art. 4º, § 1º, da',
                    ],
                rotinaIntegracao: importaPropostaMAG,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaPropostas,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoProposta,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "PROPOSTA",
                        "STATUS",
                        "NOME PROPONENTE",
                        "ACEITE AUTOMÁTICO",
                        "UP",
                        "ENTRADA",
                        "ACEITE",
                        "IMPLANTAÇÃO",
                        "ULTIMA ALTERAÇÃO",
                        "PRIMEIRO PAGAMENTO",
                        "PRIMEIRA APROPRIAÇÃO",
                        "DATA PRIMEIRA ANGARIAÇÃO",
                        "EMISSÃO",
                        "CICLO PROPOSTA (DIAS)",
                        "PRÊMIO TOTAL",
                        "PRÊMIO RISCO",
                        "PRÊMIO ANUALIZADO RISCO",
                        "PRÊMIO RISCO LÍQUIDO",
                        "VALOR LIQUIDO EMITIDO",
                        "VALOR LIQUIDO ANUALIZADO EMITIDO",
                        "PERIODICIDADE",
                        "FORMA PAGAMENTO",
                        "FORMA PRIMEIRA COBRANÇA",
                        "OFERTA COMERCIAL",
                        "AM",
                        "AD",
                        "TEXTO SUSPENSÃO",
                        "TEXTO RECUSA",
                        "CPF / CNPJ",
                        "SEXO",
                        "NASCIMENTO",
                        "PROFISSÃO",
                        "RENDA",
                        "UF",
                        "CIDADE",
                        "CEP",
                        "BAIRRO",
                        "EMAIL",
                        "DDD",
                        "TELEFONE",
                        "PRODUTOR 1",
                        "NOME PRODUTOR 1",
                        "PRODUTOR 2",
                        "NOME PRODUTOR 2",
                        "CODIGO AGENTE MAG",
                        "NOME AGENTE MAG",
                        "CODIGO AGENTE FIDELIZAÇÃO",
                        "NOME AGENTE FIDELIZAÇÃO",
                        "CODIGO GERENTE COMERCIAL",
                        "NOME GERENTE COMERCIAL",
                        "CODIGO GERENTE SUCURSAL",
                        "NOME GERENTE SUCURSAL",
                        "OPERAÇÃO",
                        "CANAL",
                        "EMPRESA ACORDO COMERCIAL",
                    ],
                rotinaIntegracao: importaListaPropostasMAG,
                statusProposta: statusPropostaMAG,
                tipoPeriodicidadePagtoPremio: tipoPeriodicidadePagtoPremioMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaPropostasNovoLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoProposta,
                cabecalho: 0,
                chaveIntegracao:
                /*[
                    "PROPOSTA",
                    "STATUS",
                    "PROPONENTE",
                    "OFERTA",
                    "GRUPO",
                    "NEGÓCIO",
                    "ACEITE AUTOMÁTICO",
                    "ENTRADA",
                    "ACEITE",
                    "ÚLTIMA ALTERAÇÃO",
                    "IMPLANTAÇÃO",
                    "EMISSÃO",
                    "PRÊMIO TOTAL",
                    "PRÊMIO RISCO",
                    "PRÊMIO ANUALIZADO RISCO",
                    "PRÊMIO MENSALIZADO RISCO",
                    "PRÊMIO SGV",
                    "PERIODICIDADE",
                    "TEM PRIMEIRO PAGAMENTO ?",
                    "PRÊMIO PRIMEIRO PAGAMENTO",
                    "FORMA PAGAMENTO",
                    "PRIMEIRA COBRANÇA",
                    "PAGAMENTO",
                    "APROPRIAÇÃO",
                    "CANCELAMENTO",
                    "MOTIVO",
                    "AM",
                    "MIGRAÇÃO",
                    "AD",
                    "DATA SUSPENSÃO",
                    "TEXTO SUSPENSÃO",
                    "DATA RECUSA",
                    "TEXTO RECUSA",
                    "UNIDADE DE PRODUÇÃO",
                    "REGIONAL",
                    "DIRETORIA",
                    "CPF",
                    "TELEFONE",
                    "E-MAIL",
                    "SEXO",
                    "NASCIMENTO",
                    "ESTADO CIVIL",
                    "RENDA",
                    "PROFISSÃO",
                    "CEP",
                    "CIDADE",
                    "UF",
                    "EMPRESA ACORDO COMERCIAL",
                    "CNPJ EMPRESA",
                    "OPERACAO",
                    "PRODUTOR 1",
                    "PRODUTOR 2",
                    "PRODUTOR 3",
                    "PRODUTOR 4",
                    "PRODUTOR 5",
                    "PRODUTOR 6",
                    "PRODUTOR 7",
                    "PRODUTOR 8",
                    "PRODUTOR 9"
                ]*/
                [
                    "PROPOSTA",
                    "STATUS",
                    "PROPONENTE",
                    "OFERTA",
                    "GRUPO",
                    "NEGÓCIO",
                    "ACEITE AUTOMÁTICO",
                    "ENTRADA",
                    "ACEITE",
                    "ÚLTIMA ALTERAÇÃO",
                    "IMPLANTAÇÃO",
                    "SGV", // Novo
                    "EMISSÃO",
                    "PRÊMIO TOTAL",
                    "PRÊMIO RISCO",
                    "PRÊMIO ANUALIZADO RISCO",
                    "PRÊMIO MENSALIZADO RISCO",
                    "PRÊMIO SGV",
                    "PERIODICIDADE",
                    "TEM PRIMEIRO PAGAMENTO ?",
                    "PRÊMIO PRIMEIRO PAGAMENTO",
                    "FORMA PAGAMENTO",
                    "FICHA FINANCEIRA",
                    "PRIMEIRA COBRANÇA",
                    "VENCIMENTO",
                    "PAGAMENTO",
                    "APROPRIAÇÃO",
                    "CANCELAMENTO",
                    "MOTIVO",
                    "AM",
                    "MIGRAÇÃO",
                    "AD",
                    "DATA SUSPENSÃO",
                    "TEXTO SUSPENSÃO",
                    "DATA RECUSA",
                    "TEXTO RECUSA",
                    "UNIDADE DE PRODUÇÃO",
                    "REGIONAL",
                    "DIRETORIA",
                    "CPF",
                    "TELEFONE",
                    "E-MAIL",
                    "SEXO",
                    "NASCIMENTO",
                    "ESTADO CIVIL",
                    "RENDA",
                    "PROFISSÃO",
                    "CEP",
                    "CIDADE",
                    "UF",
                    "EMPRESA ACORDO COMERCIAL",
                    "CNPJ EMPRESA",
                    "OPERACAO",
                    "PRODUTOR PRINCIPAL",
                    "AGENCIA / ASSESSORIA",
                    "CORRETOR ESTRUTURADO",
                    "CORRETOR MICRO PJ",
                    "CORRETOR PJ",
                    "CORRETOR PL",
                    "CORRETOR NIVEL 4",
                    "CORRETOR",
                    "CONSULTOR B2C",
                    "CONSULTOR / REPRESENTANTE",
                    "PROMOTOR / AGENTE COMERCIAL",
                    "TREINANDO / OPERADOR",
                    "GERENTE COMERCIAL",
                    "GERENTE EXECUTIVO",
                    "MTZ / ISLA",
                    "SUPERINTENDENTE COMERCIAL",
                    "SUPERINTENDENTE REGIONAL"
                ],
                rotinaIntegracao: importaListaPropostasMAGNovoLayout,
                statusProposta: statusPropostaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaPropostasImplantacao,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "PROPOSTA IMPLANTAÇÃO",
                        "STATUS",
                        "NOME PROPONENTE",
                        "ACEITE AUTOMÁTICO",
                        "UP",
                        "ENTRADA",
                        "ACEITE",
                        "IMPLANTAÇÃO",
                        "ULTIMA ALTERAÇÃO",
                        "PRIMEIRO PAGAMENTO",
                        "PRIMEIRA APROPRIAÇÃO",
                        "DATA PRIMEIRA ANGARIAÇÃO",
                        "EMISSÃO",
                        "CICLO PROPOSTA (DIAS)",
                        "PRÊMIO TOTAL",
                        "PRÊMIO RISCO",
                        "PRÊMIO ANUALIZADO RISCO",
                        "PRÊMIO RISCO LÍQUIDO",
                        "VALOR LIQUIDO EMITIDO",
                        "VALOR LIQUIDO ANUALIZADO EMITIDO",
                        "PERIODICIDADE",
                        "FORMA PAGAMENTO",
                        "FORMA PRIMEIRA COBRANÇA",
                        "OFERTA COMERCIAL",
                        "AM",
                        "AD",
                        "TEXTO SUSPENSÃO",
                        "TEXTO RECUSA",
                        "CPF / CNPJ",
                        "SEXO",
                        "NASCIMENTO",
                        "PROFISSÃO",
                        "RENDA",
                        "UF",
                        "CIDADE",
                        "CEP",
                        "BAIRRO",
                        "EMAIL",
                        "DDD",
                        "TELEFONE",
                        "PRODUTOR 1",
                        "NOME PRODUTOR 1",
                        "PRODUTOR 2",
                        "NOME PRODUTOR 2",
                        "CODIGO AGENTE MAG",
                        "NOME AGENTE MAG",
                        "CODIGO AGENTE FIDELIZAÇÃO",
                        "NOME AGENTE FIDELIZAÇÃO",
                        "CODIGO GERENTE COMERCIAL",
                        "NOME GERENTE COMERCIAL",
                        "CODIGO GERENTE SUCURSAL",
                        "NOME GERENTE SUCURSAL",
                        "OPERAÇÃO",
                        "CANAL",
                        "EMPRESA ACORDO COMERCIAL",
                    ],
                rotinaIntegracao: importaListaPropostasImplantacaoMAG,
                statusProposta: statusPropostaMAG,
                tipoPeriodicidadePagtoPremio: tipoPeriodicidadePagtoPremioMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolicePrivateSolutions,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Private',
                        'Solutions',
                        'Mongeral Aegon Seguros e Previdência S.A.', 
                        'da Apólice',
                    ],
                rotinaIntegracao: importaApoliceMAGPrivateSolutions,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceVidaToda,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'CERTIFICADO / APÓLICE DE SEGURO / PLANO DE PREVIDÊNCIA',
                        'Mongeral Aegon Seguros e Previdência S.A.',
                        'DADOS DOS PLANOS', //' DE MORTE OU INVALIDEZ',
                        //'Apólice Início / Período de Vigência',//'Controle da Apólice',
                        'Apólice',
                        'Início / Período de',
                        'Vigência',
                    ],
                rotinaIntegracao: importaApoliceMAGVidaToda,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacao,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    "NEGÓCIO",
                    "CPF",
                    "SEGURADO",
                    "MATRICULA",
                    "PROPOSTA",
                    "DATA ENTRADA", //novo
                    "DATA IMPLANTAÇÃO",
                    "DATA EMISSÃO",
                    "UNIDADE DE PRODUÇÃO",
                    "REGIONAL",
                    "DIRETORIA",
                    "OFERTA COMERCIAL",
                    "GRUPO OFERTA",
                    "AM",
                    "AD",
                    "INSCRIÇÃO",
                    "SITUAÇÃO INSCRIÇÃO",
                    "DATA SITUAÇÃO",
                    "CANCELAMENTO AGENDADO",
                    "ITEM CONTRATADO",
                    "PRODUTO",
                    "TEMPO CONTRIBUIÇÃO (ANOS)", //novo
                    "PRAZO DECRECIMO", //novo
                    "PRAZO DIFERIMENTO", //novo
                    "CAPITAL SEGURADO",
                    "REGIME FINANCEIRO",
                    "ÍNICIO VIGÊNCIA",
                    "FIM VIGÊNCIA",
                    "STATUS ITEM",
                    "DATA STATUS",
                    "PERIODICIDADE",
                    "FORMA COBRANÇA",
                    "DIA VENCIMENTO",
                    "PRÊMIO IMPLANTADO",
                    "PRÊMIO IMPLANTADO LÍQUIDO",
                    "IOF IMPLANTADO",
                    "PRÊMIO ATUAL",
                    "IOF ATUAL",
                    "PRÊMIO ATUAL MENSALIZADO",
                    "PRÊMIO ATUAL ANUALIZADO",
                    "PRIMEIRO PAGAMENTO",
                    "FORMA COBRANÇA PRIMEIRO PAGAMENTO", //novo
                    "DATA PRIMEIRO VENCIMENTO", //novo
                    "DATA PAGAMENTO",
                    "FICHA COMISSÃO",
                    "TELEFONE CLIENTE",
                    "E-MAIL CLIENTE",
                    "ENDEREÇO CLIENTE",
                    "SEXO CLIENTE",
                    "QTD FILHOS",
                    "DATA NASCIMENTO",
                    "PROFISSÃO CLIENTE",
                    "RENDA CLIENTE",
                    "EMPRESA ACORDO COMERCIAL",
                    "CNPJ EMPRESA ACORDO COMERCIAL",
                    "OPERAÇÃO",
                    "PRODUTOR PRINCIPAL",
                    "PRODUTOR AUXILIAR",
                    "AGENCIA / ASSESSORIA",
                    "CORRETOR ESTRUTURADO",
                    "CORRETOR MICRO PJ",
                    "CORRETOR PJ",
                    "CORRETOR PL",
                    "CORRETOR NIVEL 4",
                    "CORRETOR",
                    "CONSULTOR B2C",
                    "CONSULTOR / REPRESENTANTE",
                    "PROMOTOR / AGENTE COMERCIAL",
                    "TREINANDO / OPERADOR",
                    "PRODUTOR ACORDO COMERCIAL", //novo2
                    "GERENTE COMERCIAL",
                    "GERENTE EXECUTIVO",
                    "MTZ / ISLA",
                    "SUPERINTENDENTE COMERCIAL",
                    "SUPERINTENDENTE REGIONAL",
                ],
                rotinaIntegracao: importaListaApolicesMAGImplantacao,
                statusApolice: statusApoliceMAG,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMAG,
                statusCobertura: statusCoberturaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacaoSegundoLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    "NEGÓCIO",
                    "CPF",
                    "SEGURADO",
                    "MATRICULA",
                    "PROPOSTA",
                    "DATA ENTRADA", //novo
                    "DATA IMPLANTAÇÃO",
                    "DATA EMISSÃO",
                    //"UNIDADE DE PRODUÇÃO",
                    //"REGIONAL",
                    //"DIRETORIA",
                    "OFERTA COMERCIAL",
                    "GRUPO OFERTA",
                    "AM",
                    "AD",
                    "INSCRIÇÃO",
                    "SITUAÇÃO INSCRIÇÃO",
                    "DATA SITUAÇÃO",
                    "CANCELAMENTO AGENDADO",
                    "ITEM CONTRATADO",
                    "PRODUTO",
                    "TEMPO CONTRIBUIÇÃO (ANOS)", //novo
                    "PRAZO DECRECIMO", //novo
                    "PRAZO DIFERIMENTO", //novo
                    "CAPITAL SEGURADO",
                    "REGIME FINANCEIRO",
                    "ÍNICIO VIGÊNCIA",
                    "FIM VIGÊNCIA",
                    "STATUS ITEM",
                    "DATA STATUS",
                    "PERIODICIDADE",
                    "FORMA COBRANÇA",
                    "DIA VENCIMENTO",
                    "PRÊMIO IMPLANTADO",
                    "PRÊMIO IMPLANTADO LÍQUIDO",
                    "IOF IMPLANTADO",
                    "PRÊMIO ATUAL",
                    "IOF ATUAL",
                    "PRÊMIO ATUAL MENSALIZADO",
                    "PRÊMIO ATUAL ANUALIZADO",
                    "PRIMEIRO PAGAMENTO",
                    "FORMA COBRANÇA PRIMEIRO PAGAMENTO", //novo
                    "DATA PRIMEIRO VENCIMENTO", //novo
                    "DATA PAGAMENTO",
                    "FICHA COMISSÃO",
                    "TELEFONE CLIENTE",
                    "E-MAIL CLIENTE",
                    "ENDEREÇO CLIENTE",
                    "SEXO CLIENTE",
                    "QTD FILHOS",
                    "DATA NASCIMENTO",
                    "PROFISSÃO CLIENTE",
                    "RENDA CLIENTE",
                    "EMPRESA ACORDO COMERCIAL",
                    "CNPJ EMPRESA ACORDO COMERCIAL",
                    "OPERAÇÃO",
                    //"PRODUTOR PRINCIPAL",
                    //"PRODUTOR AUXILIAR",
                    //"AGENCIA / ASSESSORIA",
                    "CORRETOR ESTRUTURADO",
                    //"CORRETOR MICRO PJ",
                    //"CORRETOR PJ",
                    //"CORRETOR PL",
                    //"CORRETOR NIVEL 4",
                    //"CORRETOR",
                    //"CONSULTOR B2C",
                    //"CONSULTOR / REPRESENTANTE",
                    //"PROMOTOR / AGENTE COMERCIAL",
                    //"TREINANDO / OPERADOR",
                    //"PRODUTOR ACORDO COMERCIAL", //novo2
                    //"GERENTE COMERCIAL",
                    //"GERENTE EXECUTIVO",
                    //"MTZ / ISLA",
                    //"SUPERINTENDENTE COMERCIAL",
                    //"SUPERINTENDENTE REGIONAL",
                ],
                rotinaIntegracao: importaListaApolicesMAGImplantacaoSegundoLayout,
                statusApolice: statusApoliceMAG,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMAG,
                statusCobertura: statusCoberturaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacaoTerceiroLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    "NEGÓCIO",
                    "CPF",
                    "SEGURADO",
                    "MATRICULA",
                    "PROPOSTA",
                    "DATA ENTRADA", //novo
                    "DATA IMPLANTAÇÃO",
                    "DATA EMISSÃO",
                    "UNIDADE DE PRODUÇÃO",
                    "REGIONAL",
                    "DIRETORIA",
                    "OFERTA COMERCIAL",
                    "GRUPO OFERTA",
                    "AM",
                    "AD",
                    "INSCRIÇÃO",
                    "SITUAÇÃO INSCRIÇÃO",
                    "DATA SITUAÇÃO",
                    "CANCELAMENTO AGENDADO",
                    "PRODUTO",
                    "TEMPO CONTRIBUIÇÃO (ANOS)", //novo
                    "PRAZO DECRECIMO", //novo
                    "PRAZO DIFERIMENTO", //novo
                    "CAPITAL SEGURADO",
                    "REGIME FINANCEIRO",
                    "ÍNICIO VIGÊNCIA",
                    "FIM VIGÊNCIA",
                    "STATUS ITEM",
                    "DATA STATUS",
                    "PERIODICIDADE",
                    "FORMA COBRANÇA",
                    "DIA VENCIMENTO",
                    "PRÊMIO IMPLANTADO",
                    "PRÊMIO IMPLANTADO LÍQUIDO",
                    "IOF IMPLANTADO",
                    "PRÊMIO ATUAL",
                    "IOF ATUAL",
                    "PRÊMIO ATUAL MENSALIZADO",
                    "PRÊMIO ATUAL ANUALIZADO",
                    "PRIMEIRO PAGAMENTO",
                    "FORMA COBRANÇA PRIMEIRO PAGAMENTO", //novo
                    "DATA PRIMEIRO VENCIMENTO", //novo
                    "DATA PAGAMENTO",
                    "FICHA COMISSÃO",
                    "TELEFONE CLIENTE",
                    "E-MAIL CLIENTE",
                    "ENDEREÇO CLIENTE",
                    "SEXO CLIENTE",
                    "QTD FILHOS",
                    "DATA NASCIMENTO",
                    "PROFISSÃO CLIENTE",
                    "RENDA CLIENTE",
                    "EMPRESA ACORDO COMERCIAL",
                    "CNPJ EMPRESA ACORDO COMERCIAL",
                    "OPERAÇÃO",
                    "PRODUTOR PRINCIPAL",
                    "PRODUTOR AUXILIAR",
                    "AGENCIA / ASSESSORIA",
                    "CORRETOR ESTRUTURADO",
                    "CONSULTOR B2C",
                    "PROMOTOR / AGENTE COMERCIAL",
                    "SUPERINTENDENTE REGIONAL",
                ],
                rotinaIntegracao: importaListaApolicesMAGImplantacaoTerceiroLayout,
                statusApolice: statusApoliceMAG,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMAG,
                statusCobertura: statusCoberturaMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaCobrancas,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCobranca,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'COMPETÊNCIA CONTRIBUIÇÃO',
                        'COMPETÊNCIA PREVISÃO RETORNO',
                        'MODULO',
                        'NOME CLIENTE',
                        'DOCUMENTO CLIENTE',
                        'TELEFONE',
                        'E-MAIL',
                        'MATRICULA',
                        'PROPOSTA',
                        'DATA IMPLANTAÇÃO',
                        'UP',
                        'INSCRIÇÃO',
                        'DATA SITUAÇÃO',
                        'SITUAÇÃO INSCRIÇÃO',
                        'CANCELAMENTO AGENDADO',
                        'PRODUTO',
                        'REGIME FINANCEIRO',
                        'PERIODICIDADE',
                        'PARCELA',
                        'STATUS CONTRIBUIÇÃO',
                        'DATA EMISSÃO PRÊMIO',
                        'DATA PREVISÃO FATURAMENTO',
                        'DATA VENCIMENTO',
                        'DATA PREVISÃO RETORNO',
                        'DATA ENTRADA INADIMPLENTE',
                        'PARCELAS EM ABERTO',
                        'DATA PAGAMENTO',
                        'DATA APROPRIAÇÃO',
                        'VALOR CONTRIBUIÇÃO',
                        'VALOR FATURADO',
                        'VALOR APROPRIADO',
                        'VALOR IOF APROPRIADO',
                        'FORMA PAGAMENTO',
                        'FORMA COBRANÇA',
                        'TIPO RETORNO',
                        'STATUS RETORNO',
                        //'PLATAFORMA',
                        'HISTÓRICO COBRANÇA',
                        'DADOS BANCÁRIOS',
                        'OFERTA COMERCIAL',
                        'GRUPO OFERTA COMERCIAL',
                        'EMPRESA ACORDO COMERCIAL PROPOSTA',
                        'UNIDADE DE PRODUÇÃO',
                        'REGIONAL',
                        'DIRETORIA',
                        'OPERACAO',
                        'PRODUTOR PRINCIPAL',
                        'PRODUTOR AUXILIAR',
                        'AGENCIA / ASSESSORIA',
                        'CORRETOR ESTRUTURADO',
                        'CORRETOR MICRO PJ',
                        'CORRETOR PJ',
                        'CORRETOR PL',
                        'CORRETOR NIVEL 4',
                        'CORRETOR',
                        'CONSULTOR B2C',
                        'CONSULTOR / REPRESENTANTE',
                        'PROMOTOR / AGENTE COMERCIAL',
                        'TREINANDO / OPERADOR',
                        'PRODUTOR ACORDO COMERCIAL',
                        'GERENTE COMERCIAL',
                        'GERENTE EXECUTIVO',
                        'MTZ / ISLA',
                        'SUPERINTENDENTE COMERCIAL',
                        'SUPERINTENDENTE REGIONAL',
                    ],
                rotinaIntegracao: importaListaCobrancasMAG,
                tipoPeriodicidadePagtoPremio: tipoPeriodicidadePagtoPremioMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        /*
                        'Neg',
                        'Prop / Cont',
                        'Insc / Subest',
                        'Mat / Ind',
                        'Cliente',
                        'Produtor',
                        'UP',
                        '% Part',
                        'Alt',
                        'Prod',
                        'Parc. Comissão',
                        'Competência Arrecadação',
                        'Parc. Arrecadação',
                        '$ Base', '% Com',
                        '$ COM', 'Evento',
                        'Envio', 'Agend',
                        'Pagto',
                        'DG',
                        'AD',
                        'AM',
                        'Fato',
                        'Desc Prov',
                        'Condição Comercial',
                        'Provisão',
                        'Tipo Pagto',
                        '% Co-Corretagem',
                        'Comissão Co-Corretagem',
                        'Produtor Co-Corretagem',
                        'CPF Cliente',
                        'Prazo tempo / idade',
                        'Ativo',
                        'Com total'
                        */
                        'CPF/CNPJ do Produtor',
                        'Código do produtor',
                        'Tipo de cliente',
                        'Nome/Razão social',
                        'CPF/CNPJ do cliente',
                        'Proposta',
                        'UP da venda',
                        'Nº Inscrição',
                        'Descrição Produto',
                        'Código do produto',
                        'Valor base',
                        'Parcela comissionada',
                        'Competência comissionada',
                        'Parcela faturada',
                        'Competência faturada',
                        'Descrição Provisão',
                        'Tipo de lançamento',
                        'Data prevista',
                        'Data de efetivação do crédito/débito',
                        'Valor Angariação',
                        '%  Angariação',
                        'Valor Comissão',
                        '%  Comissão',
                        'Valor estorno',
                        '% estorno',
                        'Valor incentivo',
                        '%  incentivo',
                        'Valor bonificação',
                        '%  bonificação',
                        'Código da Verba',
                        'Nome da Verba',
                        'Alternativa',
                        'AD',
                        'AM',
                        'Fato gerador',
                        'Tipo de pagamento',
                    ],
                rotinaIntegracao: importaListaComissoesMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoesSegundoLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'Neg---', // Inativo até que seja identificado o campo cnpjEmpresa
                        'Prop / Cont',
                        'Insc / Subest',
                        'Mat / Ind',
                        'Cliente',
                        'Documento Cliente',
                        'Produtor',
                        'Id. Externo',
                        'UP',
                        '% Part',
                        'Alt',
                        'Prod',
                        'Parc. Comissão',
                        'Competência Arrecadação',
                        'Parc. Arrecadação',
                        '$ Base',
                        '% Com',
                        '$ COM',
                        'Evento',
                        'Envio',
                        'Agend',
                        'Pagto',
                        'DG',
                        'AD',
                        'AM',
                        'Fato',
                        'Desc Prov',
                        'Condição Comercial',
                        'Prov',
                        'Tipo Pagto',
                        'Ativo'
                    ],
                rotinaIntegracao: importaListaComissoesMAGSegundoLayout,
            },
        ],
        integracaoAvulso: [
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Preparamos um estudo personalizado',
                        'Private Solutions.',
                        'Essa linha também possui opções de planos de previdência PGBL', // e VGBL',
                        'não constituem nenhuma garantia de rentabilidade por parte da MAG Seguros para seus participantes.',
                    ],
                rotinaIntegracao: importaCotacaoMAGTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Preparamos um estudo personalizado',
                        'Private Solutions.',
                        'Essa linha também possui opções de planos de previdência PGBL e VGBL',
                        'não constituem garantia por parte da MAG Seguros. A aceitação do(s) seguro(s) está sujeita à análise de risco e condicionada à política de aceitação',// vigente',
                    ],
                rotinaIntegracao: importaCotacaoMAGTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Preparamos um estudo exclusivo', // para você!',
                        'As recomendações apresentadas foram elaboradas com base nos planos da linha Vida Toda',
                        'A MAG',
                        'PRIVATE SOLUTIONS',
                        'Detalhes desta simulação e indicação de documentos que podem ser necessários.',
                        'www.mag.com.br',
                    ],
                rotinaIntegracao: importaCotacaoMAGTabelaEvolucaoValorResgateNovoLayout,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'Preparamos um estudo exclusivo', // para você!',
                        'As recomendações apresentadas foram elaboradas com base nos planos da linha Private',
                        'A MAG',
                        'PRIVATE SOLUTIONS',
                        'Detalhes desta simulação e indicação de documentos que podem ser necessários.',
                        'www.mag.com.br',
                    ],
                rotinaIntegracao: importaCotacaoMAGTabelaEvolucaoValorResgateNovoLayout,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
        ],
        ordem: 120,
    },
    {
        id: 130,
        descricao: 'MBM',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 130,
    },
    {
        id: 140, // HARDCODE.idInstituicaoFinanceiraMAPFRE
        descricao: 'MAPFRE',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        SvgConsorcioLogo: SvgImageParceirosMAPFREConsorcioLogo,
        //svgConsorcioLogoMl: '27',
        tipoLanceList: [
            {id: 'TF', descricao: 'Lance Troca Fácil'},
            {id: 'CF', descricao: 'Lance Contrufácil'},
            {id: 'QF', descricao: 'Lance Quitafácil'},
        ],
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesPlataforma,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 1,
                chaveIntegracao:
                    [
                        "Código Arvore",
                        "Código Agente",
                        "Número Apolice",
                        "Cotação",
                        "Cliente",
                        "CPF",
                        "Data da Cotação",
                        "Data Inicio Vigencia",
                        "Status Apolice",
                        "Vlr IS Morte",
                        "Premio Morte",
                        "Prazo Cobertura Morte",
                        "VLR Sobrev",
                        "Premio Sobrev",
                        "Prazo Cobertura Sobrevivência",
                        "Vlr IS IPA",
                        "Premio IPA",
                        "Prazo Cobertura Invalidez",
                        "Vlr DG",
                        "Premio DG",
                        "Prazo DG",
                        "Sexo",
                        "Classificação Risco",
                        "Data de Nascimento",
                        "Idade atual",
                        "Idade de saida",
                        "Capital morte",
                        "Capital Sobrevivência",
                        "Periodicidade de Pagamento",
                        "Tipo de Plano",
                        "Percentual Rentabilidade Estimada",
                        "Prêmio Total",
                        "Estado Civil",
                        "Profissão",
                        "Telefone Residencial",
                        "Telefone Comercial",
                        "Telefone Celular",
                        "Tipo de Documento",
                        "Orgão Expedidor",
                        "UF Expedidor",
                        "No. Documento",
                        "Data de Expedição",
                        "Nacionalidade",
                        "Faixa de Renda",
                        "Logradouro Residencial",
                        "Número Residencial",
                        "Complemento Residencial",
                        "Bairro Residencial",
                        "Municipio Residencial",
                        "UF Residencial",
                        "CEP Residencial",
                        "Pais Residencial",
                        "Reside no pais",
                        "Receber informação eletrônica",
                        "Email",
                        "Logradouro Correspondência",
                        "Número Correspondência",
                        "Complemento Correspondência",
                        "Bairro Correspondência",
                        "Município Correspondência",
                        "UF Correspondência",
                        "CEP Correspondência",
                        "País  Correspondência",
                        "Nome Beneficiário",
                        "Data Nascimento Beneficiário",
                        "Grau de Parentesco Beneficiário",
                        "CPF Beneficiário",
                        "Percentual participação benfeciario",
                        "Tipo de Cobertura"
                    ],
                rotinaIntegracao: importaListaApolicesMAPFRE,
                statusApolice: [
                    {id: 'ATIVA', idConversao: HARDCODE.idStatusApoliceAtiva},
                    {id: 'CANCELADA', idConversao: HARDCODE.idStatusApoliceCancelada},
                ],
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesCorretorSeguros,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "Código Arvore",
                        "Código Agente",
                        "Número Apolice",
                        "Cotação",
                        "Cliente",
                        "CPF",
                        "Data da Cotação",
                        "Data Inicio Vigencia",
                        "Status Apolice",
                        "Vlr IS Morte",
                        "Premio Morte",
                        "Prazo Cobertura Morte",
                        "VLR Sobrev",
                        "Premio Sobrev",
                        "Prazo Cobertura Sobrevivência",
                        "Vlr IS IPA",
                        "Premio IPA",
                        "Prazo Cobertura Invalidez",
                        "Vlr DG",
                        "Premio DG",
                        "Prazo DG",
                        "Sexo",
                        "Classificação Risco",
                        "Data de Nascimento",
                        "Idade atual",
                        "Idade de saida",
                        "Capital morte",
                        "Capital Sobrevivência",
                        "Periodicidade de Pagamento",
                        "Tipo de Plano",
                        "Percentual Rentabilidade Estimada",
                        "Prêmio Total",
                        "Estado Civil",
                        "Profissão",
                        "Telefone Residencial",
                        "Telefone Comercial",
                        "Telefone Celular",
                        "Tipo de Documento",
                        "Orgão Expedidor",
                        "UF Expedidor",
                        "No. Documento",
                        "Data de Expedição",
                        "Nacionalidade",
                        "Faixa de Renda",
                        "Logradouro Residencial",
                        "Número Residencial",
                        "Complemento Residencial",
                        "Bairro Residencial",
                        "Municipio Residencial",
                        "UF Residencial",
                        "CEP Residencial",
                        "Pais Residencial",
                        "Reside no pais",
                        "Receber informação eletrônica",
                        "Email",
                        "Logradouro Correspondência",
                        "Número Correspondência",
                        "Complemento Correspondência",
                        "Bairro Correspondência",
                        "Município Correspondência",
                        "UF Correspondência",
                        "CEP Correspondência",
                        "País  Correspondência",
                        "Nome Beneficiário",
                        "Data Nascimento Beneficiário",
                        "Grau de Parentesco Beneficiário",
                        "CPF Beneficiário",
                        "Percentual participação benfeciario",
                        "Tipo de Cobertura"
                    ],
                rotinaIntegracao: importaListaApolicesMAPFRE,
                statusApolice: [
                    {id: 'ATIVA', idConversao: HARDCODE.idStatusApoliceAtiva},
                    {id: 'CANCELADA', idConversao: HARDCODE.idStatusApoliceCancelada},
                ],
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaCobrancasPlataforma,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCobranca,
                cabecalho: 1,
                chaveIntegracao:
                    [
                        "Código Arvore",
                        "Código Agente",
                        "Número Apolice",
                        "Cliente",
                        "CPF",
                        "Data Inicio Vigencia",
                        "Status Apolice",
                        "Forma de Pagamento",
                        "Banco",
                        "Agência",
                        "Conta",
                        "Segmento",
                        "Dia de Vencimento",
                        "Número da Parcela",
                        "Estado Parcela",
                        "Retorno de OMF",
                        "Tipo",
                        "Data Vencimento",
                        "Data de Competência",
                        "Início de vigência",
                        "Fim da Vigência",
                        "Data de Pagamento",
                        "Data de Corte",
                        "Valor a Pagar",
                        "Valor Pago",
                        "Periodicidade de Pagamento",
                        "Repiques",
                        "OMF",
                    ],
                rotinaIntegracao: importaListaCobrancasMAPFRE,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaCobrancasCorretorSeguros,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCobranca,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "Código Arvore",
                        "Código Agente",
                        "Número Apolice",
                        "Cliente",
                        "CPF",
                        "Data Inicio Vigencia",
                        "Status Apolice",
                        "Forma de Pagamento",
                        "Banco",
                        "Agência",
                        "Conta",
                        "Segmento",
                        "Dia de Vencimento",
                        "Número da Parcela",
                        "Estado Parcela",
                        "Retorno de OMF",
                        "Tipo",
                        "Data Vencimento",
                        "Data de Competência",
                        "Início de vigência",
                        "Fim da Vigência",
                        "Data de Pagamento",
                        "Data de Corte",
                        "Valor a Pagar",
                        "Valor Pago",
                        "Periodicidade de Pagamento",
                        "Repiques",
                        "OMF",
                    ],
                rotinaIntegracao: importaListaCobrancasMAPFRE,
            },
        ],
        ordem: 140,
    },
    {
        id: 150,
        descricao: 'MetLife',
        SvgLogo: SvgImageParceirosMetLifeLogo,
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoProposta,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Proposta de Contratação de seguro de vida', 
                        'a favor da Metropolitan Life Seguros e Previdência Privada S.A.',
                        'INFORMAÇÕES MÉDICAS e DECLARAÇÃO PESSOAL DE SAÚDE, bem como que a presente contratação está sendo efetuada',
                    ],
                rotinaIntegracao: importaPropostaMetLife,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMetLife,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoPropostaNovoLayout,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Aceita receber as comunicações e informações sobre o seu seguro de forma eletrônica?',
                        'Proposta de Contratação de seguro de vida', 
                        'Metropolitan Life Seguros e Previdência Privada S.A.',
                        'item INFORMAÇÕES MÉDICAS e DECLARAÇÃO PESSOAL DE SAÚDE, bem como que a presente contratação',
                    ],
                rotinaIntegracao: importaPropostaMetLifeNovoLayout,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMetLife,
            },
            
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaPropostasImplantacao,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 1,
                chaveIntegracao:
                    [
                        'ID Documento Implantação',
                        'Origem',
                        'Número Proposta',
                        'Status',
                        'Data Protocolo',
                        'Nome Proponente',
                        'CPF Proponente', // alterado
                        'Data alteração status',
                        'Consultor',
                        'CPF Consultor', // novo
                        'LU',
                        'LA',
                        'Diretor',
                        'Prêmio',
                        'Data Agendamento 1',
                        'Data Agendamento 2',
                        'Data Agendamento 3',
                        'Periodicidade do Pagamento',
                        'Informações Adicionais',
                        'Morte',
                        'Amparo Funeral Cônjuge', // new
                        'Amparo Funeral Familiar', // new
                        'Amparo Funeral Familiar + Pais', // new
                        'Amparo Funeral Individual', // new
                        'Cirurgias', // new
                        'Doenças Graves Mais Proteção', // new
                        'Diária de internação hospitalar', // new
                        'Diária por Incapacidade Temporária', // new
                        'Doenças graves e procedimento cirúrgicos', // new
                        'Doenças graves e procedimento cirúrgicos premium',  // new
                        'Fratura Óssea', // new
                        'Funeral Cônjuge', // mudou de posição
                        'Funeral Individual', // mudou de posição
                        'Invalidez Acidental Majorada', // new
                        'Invalidez Permanente por Doença Funcional', // new
                        'Invalidez permanente total ou parcial por acidente', // new
                        'Morte acidental', // mudou de posição e título
                        'Morte com capital segurado decrescente', //'Morte com capital decrescente', // mudou de nome
                        'Temporária por Morte',
                        'Doenças Incapacitantes Ampliadas',
                        'Doenças Incapacitantes',
                        //'Morte Acidental', // mudou de posição e título
                        //'Invalidez Acidental', // saiu
                        //'Doenças graves e proc. Cirúrgico', // saiu
                        //'Doenças graves e proc. Cirúrgico Premium', // saiu
                        //'Diária Internação Hospitalar', // saiu
                        //'Funeral Individual', // mudou de posição
                        //'Funeral Conjugue', // mudou de posição
                        //'Proteção Incapacidade Temporaria', // saiu
                        'Telefone Proponente',
                        'Email Proponente',
                        'Estado Civil',
                        'Cidade',
                        'Data Nascimento',
                        'Forma Pagamento',
                        'Idade',
                        'Profissão',
                        'Renda',
                        'Plano',
                        'Histórico'
                    ],
                rotinaIntegracao: importaListaPropostasImplantacaoMetLife,
                statusProposta: statusPropostaMetLife,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaPropostas,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoProposta,
                cabecalho: 1,
                chaveIntegracao:
                    [
                        'ID Documento',
                        'Origem',
                        'Número Proposta',
                        'Status',
                        'Data Protocolo',
                        'Nome Proponente',
                        'CPF',
                        'Data alteração status',
                        'Consultor',
                        'LU',
                        'LA',
                        'Diretor',
                        'Prêmio',
                        'Data Agendamento 1',
                        'Data Agendamento 2',
                        'Data Agendamento 3',
                        'Periodicidade do Pagamento',
                        'Informações Adicionais',
                        'Morte',
                        'Morte com capital decrescente',
                        'Morte Acidental',
                        'Invalidez Acidental',
                        'Doenças graves e proc. Cirúrgico',
                        'Doenças graves e proc. Cirúrgico Premium',
                        'Diária Internação Hospitalar',
                        'Funeral Individual',
                        'Funeral Conjugue',
                        'Proteção Incapacidade Temporaria',
                        'Telefone Proponente',
                        'Email Proponente',
                        'Estado Civil',
                        'Cidade',
                        'Data Nascimento',
                        'Forma Pagamento',
                        'Idade',
                        'Profissão',
                        'Renda',
                        'Plano',
                        'Histórico'
                    ],
                rotinaIntegracao: importaListaPropostasMetLife,
                statusProposta: statusPropostaMetLife,
            },
            //{
            //    tipoArquivo: HARDCODE.idTipoArquivoApoliceNovoLayout,
            //    XLSXPDF: HARDCODE.PDF,
            //    tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
            //    tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
            //    chaveIntegracao:
            //        [
            //            'Apólice individual do seguro', 
            //            'Metropolitan Life Seguros e Previdência Privada S',
            //            //'O valor indicado representa o capital máximo da garantia, sendo que o cálculo da indenização observará',
            //            'As Coberturas contratadas terão seu início e término de vigência às 24 horas das datas acima indicadas. Os Capitais de',
            //        ],
            //    rotinaIntegracao: importaApoliceMetLifeNovoLayout,
            //},
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Apólice individual do seguro', 
                        'Metropolitan Life Seguros e Previdência Privada S',
                        //'ou recomendação a sua comercialização. As condições contratuais deste produto encontram-se registradas na Susep',
                        'controle dos mercados de seguro, previdência complementar aberta, capitalização, resseguro e corretagem de ',
                    ],
                rotinaIntegracao: importaApoliceMetLife,
                cobertura1: [
                    {
                        id: 1,
                        chave: 'Morte 91-Vida Individual',
                        descricaoCobertura: 'MORTE',// (91-VIDA INDIVIDUAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira,
                    },
                    {
                        id: 2,
                        chave: 'Morte Acidental 81-Acidentes Pessoais',
                        descricaoCobertura: 'MORTE ACIDENTAL',// (81-ACIDENTES PESSOAIS)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental,
                    },
                    {
                        id: 3,
                        chave: 'Invalidez Total ou Parcial por Acidente 81-Acidentes Pessoais',
                        descricaoCobertura: 'INVALIDEZ TOTAL OU PARCIAL POR ACIDENTE',// (81-ACIDENTES PESSOAIS)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial,
                    },
                    {
                        id: 4,
                        chave: 'Doenças Graves e Procedimentos Cirúrgicos Premium 84-Doença Grave ou Terminal',
                        descricaoCobertura: 'DOENÇAS GRAVES E PROCEDIMENTOS CIRÚRGICOS PREMIUM',// (84-DOENÇA GRAVE OU TERMINAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves,
                    },
                    {
                        id: 5,
                        chave: 'Cirúrgicos 84-Doença Grave ou Terminal',
                        descricaoCobertura: 'DOENÇAS GRAVES E PROCEDIMENTOS CIRÚRGICOS',// (84-DOENÇA GRAVE OU TERMINAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves,
                    },
                    {
                        id: 6,
                        chave: '84-Doença Grave ou Terminal',
                        descricaoCobertura: 'DOENÇAS GRAVES E PROCEDIMENTOS CIRÚRGICOS PREMIUM',// (84-DOENÇA GRAVE OU TERMINAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves,
                    },
                    {
                        id: 7,
                        chave: 'Doenças Incapacitantes Ampliada 90-Eventos Aleatórios',
                        descricaoCobertura: 'DOENÇAS INCAPACITANTES AMPLIADA',// (90-EVENTOS ALEATÓRIOS)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves,
                    },
                    {
                        id: 8,
                        chave: 'Doenças Graves Mais Proteção 84-Doença Grave ou Terminal',
                        descricaoCobertura: 'DOENÇAS GRAVES MAIS PROTEÇÃO',// (84-DOENÇA GRAVE OU TERMINAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves,
                    },
                    {
                        id: 9,
                        chave: 'Diária de Internação Hospitalar 90-Eventos Aleatórios',
                        descricaoCobertura: 'DIÁRIA DE INTERNAÇÃO HOSPITALAR',// (90-EVENTOS ALEATÓRIOS)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH,
                    },
                    {
                        id: 10,
                        chave: 'Fratura Óssea 90-Eventos Aleatórios',
                        descricaoCobertura: 'FATURA ÓSSEA',// (90-VIDA INDIVIDUAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaQuebraOssos,
                    },
                    {
                        id: 11,
                        chave: 'Funeral Individual 29-Funeral',
                        descricaoCobertura: 'FUNERAL INDIVIDUAL',// (29-FUNERAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral,
                    },
                    {
                        id: 12,
                        chave: 'Funeral Cônjuge 29-Funeral',
                        descricaoCobertura: 'FUNERAL CONJUGE',// (29-FUNERAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral,
                    },
                    {
                        id: 13,
                        chave: 'Decrescente A Cada Ano 91-Vida Individual', // '91-Vida Individual',
                        descricaoCobertura: 'MORTE COM CAPITAL SEGURADO DECRESCENTE A CADA ANO',// (91-VIDA INDIVIDUAL)', // null,
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente,
                    },
                    {
                        id: 14,
                        chave: 'Temporária de Morte 10 anos',
                        descricaoCobertura: 'TEMPORÁRIO DE MORTE 10 ANOS',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario,
                    },
                    {
                        id: 15,
                        chave: 'Amparo Funeral Familiar',
                        descricaoCobertura: 'AMPARO FUNERAL FAMILIAR',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral,
                    },
                    {
                        id: 16,
                        chave: 'Amparo Funeral',
                        descricaoCobertura: 'AMPARO FUNERAL',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral,
                    },
                    {
                        id: 17,
                        chave: 'Temporária de Morte 25 anos',
                        descricaoCobertura: 'TEMPORÁRIO DE MORTE 25 ANOS',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporario,
                    },
                    {
                        id: 18,
                        chave: 'Cirurgias',
                        descricaoCobertura: 'CIRURGIAS',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaCirurgia,
                    },
                    {
                        id: 19,
                        chave: 'Morte com Capital Segurado Decrescente 20 anos',
                        descricaoCobertura: 'MORTE COM CAPITAL SEGURADO DECRESCENTE 20 anos',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente,
                    },
                    
                ],
                premio1: [
                    {
                        id: 2,
                        chave: 'Morte Acidental',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 3,
                        chave: 'Invalidez Total ou Parcial por Acidente',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 4,
                        chave: 'Doenças Graves e Procedimentos Cirúrgicos Premium',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 6,
                        chave: 'Cirúrgicos Premium',
                        linha: 1,
                        linha2: 0,
                    },
                    {
                        id: 5,
                        chave: 'Cirúrgicos',
                        linha: 1,
                        linha2: 1,
                    },
                    {
                        id: 7,
                        chave: 'Doenças Incapacitantes Ampliada',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 8,
                        chave: 'Doenças Graves Mais Proteção',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 9,
                        chave: 'Diária de Internação Hospitalar',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 10,
                        chave: 'Fratura Óssea',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 11,
                        chave: 'Funeral Individual',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 12,
                        chave: 'Funeral Cônjuge',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 13,
                        chave: 'Decrescente A Cada Ano', // 'Morte com Capital Segurado',
                        linha: 0,//2,
                        linha2: 0,//2,
                    },
                    {
                        id: 14,
                        chave: 'Temporária de Morte 10 anos',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 15,
                        chave: 'Amparo Funeral Familiar',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 16,
                        chave: 'Amparo Funeral',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 17,
                        chave: 'Temporária de Morte 25 anos',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 18,
                        chave: 'Cirurgias',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 19,
                        chave: 'Morte com Capital Segurado Decrescente 20 anos',
                        linha: 0,
                        linha2: 0,
                    },
                    {
                        id: 1,
                        chave: 'Morte',
                        linha: 0,
                        linha2: 0,
                    },
                ],
                cobertura2: [
                    {
                        id: 1,
                        chave: 'Morte 91-Vida Individual',
                        descricaoCobertura: 'MORTE (91-VIDA INDIVIDUAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaVidaInteira,
                    },
                    {
                        id: 2,
                        chave: '81-Acidentes Pessoais',
                        descricaoCobertura: null,
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaInvalidezPorAcidenteTotalParcial,
                    },
                    {
                        id: 3,
                        chave: 'Terminal',
                        descricaoCobertura: 'DOENÇAS GRAVES E PROCEDIMENTOS CIRÚRGICOS PREMIUM (84-DOENÇA GRAVE OU TERMINAL)',
                        proximaLinha: true,
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves,
                    },
                    {
                        id: 4,
                        chave: 'Diária de Internação Hospitalar 90-Eventos Aleatórios',
                        descricaoCobertura: 'DIÁRIA DE INTERNAÇÃO HOSPITALAR (90-EVENTOS ALEATÓRIOS)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaDIH,
                    },
                    {
                        id: 5,
                        chave: 'Funeral Individual 29-Funeral',
                        descricaoCobertura: 'FUNERAL INDIVIDUAL (29-FUNERAL)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral,
                    },
                    {
                        id: 6,
                        chave: '91-Vida Individual',
                        descricaoCobertura: null,
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaTemporarioDecrescente,
                    },
                    {
                        id: 7,
                        chave: 'Morte Acidental 81-Acidentes Pessoais',
                        descricaoCobertura: 'MORTE ACIDENTAL (81-ACIDENTES PESSOAIS)',
                        tipoCoberturaSeguroVida: HARDCODE.idTipoCoberturaSeguroVidaAcidental,
                    },
                ],
                premio2: [
                    {
                        id: 2,
                        chave: 'Invalidez Total ou Parcial por',
                        linha: 2,
                    },
                    {
                        id: 3,
                        chave: 'Cirúrgicos Premium',
                        linha: 1,
                    },
                    {
                        id: 4,
                        chave: 'Diária de Internação Hospitalar',
                        linha: 0,
                    },
                    {
                        id: 5,
                        chave: 'Funeral Individual',
                        linha: 0,
                    },
                    {
                        id: 6,
                        chave: 'Morte com Capital Segurado',
                        linha: 2,
                    },
                    {
                        id: 7,
                        chave: 'Morte Acidental',
                        linha: 0,
                    },
                    {
                        id: 1,
                        chave: 'Morte',
                        linha: 0,
                    },
                ]
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolices,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    'Nome Cliente',
                    'Sobrenome',
                    'CPF',
                    'Data de Nascimento',
                    'Sexo',
                    'Relacionamento',
                    'Nome Produto',
                    'Plano Apolice',
                    'Status Apolice',
                    'Numero Apolice',
                    'Nome Acordo',
                    'Origem',
                    'Codigo Ramo',
                    'Cobertura',
                    'Premio',
                    'Inicio Vigencia',
                    'Tipo',
                    'Administradora',
                    'Capital',
                    'Nome Ramo',
                    'Forma Pagamento Primo',
                    'Forma Pagamento',
                    'Moeda',
                    'Info_pagamento',
                    'Frequencia',
                    'Dia Faturamento',
                    'Data Ultima Atualizacao',
                    'Responsavel',
                    'Tipo Validade',
                    'Idade Emissao',
                    'Numero Sorte',
                    'Cartao Expiracao',
                    'Data Expiracao',
                    'Dia Fechamento',
                    'Data Encerramento',
                    'Data Renovacao',
                    'Automatico',
                    'Data Cancelamento',
                    'Quantidade Term',
                    'Modo',
                    'Numero Vidas',
                    'Numero Certificado',
                    'Cnpj Corretor',
                    'Codigo Administradora',
                    'Codigo Filial',
                    'Data Emissao',
                    'Proxima Renovacao',
                ],
                rotinaIntegracao: importaListaApolicesMetLife,
                statusApolice: statusApoliceMetLife,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMetLife,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacao,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 1,
                chaveIntegracao:
                [
                    "Nome Cliente",
                    "Sobrenome",
                    "Relacionamento",
                    "Nome Produto",
                    "Plano Apolice",
                    "Status Apolice",
                    "Numero Apolice",
                    "Nome Acordo",
                    "Origem",
                    "Codigo Ramo",
                    "Premio",
                    "Inicio Vigencia",
                    "Tipo",
                    "Administradora",
                    "Capital",
                    "Nome Ramo",
                    "Forma Pagamento Primo",
                    "Forma Pagamento",
                    "Moeda",
                    "Info Pagamento",
                    "Frequencia",
                    "Dia Faturamento",
                    "Data Ultima Atualizacao",
                    "Responsavel",
                    "Tipo Validade",
                    "Idade Emissao",
                    "Numero Sorte",
                    "Cartao Expiracao",
                    "Data Expiracao",
                    "Dia Fechamento",
                    "Data Encerramento",
                    "Data Renovacao",
                    "Automatico",
                    "Data Cancelamento",
                    "Quantidade Term",
                    "Modo",
                    "Numero Vidas",
                    "Numero Certificado",
                    "Cnpj Corretor",
                    "Codigo Administradora",
                    "Codigo Filial",
                    "Data Emissao",
                    "Proxima Renovacao",
                    "Cpf Cliente",
                    "Nascimento Cliente",
                    "Sexo Cliente",
                ],
                rotinaIntegracao: importaListaApolicesMetLifeImplantacao,
                statusApolice: statusApoliceMetLife,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'idProduto',
                        'nomeProduto',
                        'idLinhaNegocio',
                        'nomeLinhaNegocio',
                        'numeroApolice',
                        'certificado',
                        'codigoComissao',
                        'descricaoComissao',
                        'endosso',
                        'parcela',
                        'tipoComissao',
                        'vigencia',
                        'percComissao',
                        'valor',
                        'valorLiquido',
                        'valorBruto',
                        'cnpjcpf',
                        'numeroApoliceDemonstrativo',
                        'dataPagamento',
                        'ValorBrutoTotal',
                        'IRRF',
                        'ISS',
                        'INSS',
                        'CSLL_PIS_COFINS',
                        'ValorLiquidoTotal',
                        'FontePagadora',
                        'NumeroSusep',
                    ],
                rotinaIntegracao: importaListaComissoesMetLife,
            },
        ],
        integracaoAvulso: [
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'MetLife', 
                        'Data que a primeira cotação foi gerada:',
                        'Informações do CorretorInformações do Segurado',
                        'Ano Idade PrêmioAcumulado Resgate',
                        'Produto registrado no Processo SUSEP: Vida Total sob nº 15414.605163/2023-93, sob responsabilidade da Metropolitan Life Seguros e',
                    ],
                rotinaIntegracao: importaCotacaoMetLifeTabelaEvolucaoValorResgate,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMetLife,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'MetLife', 
                        'Informações do Segurado Informações do Corretor',
                        'Esta simulação/cotação é válida por 30 dias, contados a partir da data de elaboração.',
                        'Produto registrado no Processo SUSEP: Vida Total',
                        'sob  responsabilidade da Metropolitan Life Seguros e',
                    ],
                rotinaIntegracao: importaCotacaoMetLifeTabelaEvolucaoValorResgate,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMetLife,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'MetLife', 
                        'Informações do Segurado Informações do Corretor',
                        'Esta simulação/cotação é válida por 30 dias, contados a partir da data de elaboração.',
                        'Produto registrado no Processo SUSEP: Vida Segura',
                        'sob  responsabilidade da Metropolitan Life Seguros e',
                    ],
                rotinaIntegracao: importaCotacaoMetLifeTabelaEvolucaoValorResgate,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMetLife,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.XLSX,
                cabecalho: 42,
                chaveIntegracao:
                    [
                        null,
                        "Idade",
                        "Capital Segurado Base",
                        "Aporte Ano",
                        "Aporte Acumulado",
                        "Resgate Bruto",
                        null,
                        null,
                        0
                    ],
                rotinaIntegracao: importaCotacaoMetLifeTabelaEvolucaoValorResgateCartaAdendo,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
        ],
        ordem: 150,
    },
    {
        id: 160,
        descricao: 'Mitsui',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 160,
    },
    {
        id: 165,
        descricao: 'MunichRe',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 165,
    },
    {
        id: 170,
        descricao: 'Omint',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'APÓLICE SEGURO DE VIDA INDIVIDUAL',
                        'OMINT',
                        //'COBERTURAS ADICIONAIS CAPITALSEGURADO INÍCIO DE VIGÊNCIA FIM DE VIGÊNCIA PRÊMIO LÍQUIDO',
                        'COBERTURAS BÁSICAS CAPITALSEGURADO INÍCIO DE VIGÊNCIA FIM DE VIGÊNCIA PRÊMIO LÍQUIDO',
                        'assim como outros dados pessoais que venham ser coletados durante a execução do Contrato, a Omint Seguros observará as regras da Lei n. 13.709/2018',
                    ],
                rotinaIntegracao: importaApoliceOmint,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaOmint, // Vital e Foco
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'APÓLICE DE SEGURO DE VIDA INDIVIDUAL',
                        'OMINT',
                        'COBERTURAS CAPITAL SEGURADO INÍCIO DE VIGÊNCIA FIM DE VIGÊNCIA PRÊMIO LÍQUIDO',
                        'Este seguro é por prazo determinado, tendo a Omint Seguros a faculdade de não renovar a Apólice ao final da vigência, sem devolução dos prêmios pagos, conforme previsto nas Condições',
                    ],
                rotinaIntegracao: importaApoliceOmint,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaOmint, // Ideal
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'APÓLICE SEGURO DE VIDA INDIVIDUAL',
                        'OMINT',
                        'COBERTURAS CAPITAL SEGURADO INÍCIO DE VIGÊNCIA FIM DE VIGÊNCIA PRÊMIO LÍQUIDO',
                        'venham ser coletados durante a execução do Contrato, a Omint Seguros observará as regras da Lei n. 13.709/2018 ("Lei Geral de Proteção de Dados" ou "LGPD")',
                        'A contratação da presente Apólice somente se efetivará caso seja realizado o pagamento da primeira parcela ou parcela única do prêmio. Esta Apólice tem início de vigência às 24 horas',
                    ],
                rotinaIntegracao: importaApoliceOmint,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaOmint, // Ideal
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaCobrancas,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCobranca,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'Número da Apólice',
                        'Empresa/Segurado',
                        'CPF/CNPJ',
                        'Parcela',
                        'Forma de Pagto',
                        'Status',
                        'Vencimento',
                        'Vl. Parcela (R$)',
                        'Dt. Pagto',
                        'Vl. Comissão (R$)',
                        'cd_forma_pagamento_condicional',
                        'id_parcela_movimentacao',
                    ],
                rotinaIntegracao: importaListaCobrancasOmint,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'N° Prévia',
                        'Dt. Comissão',
                        'Produto',
                        'N° Parcela',
                        'Apólice',
                        'Nº Endosso',
                        'Bilhete',
                        'Segurado / Estipulante',
                        'Tipo de Comissão',
                        'Premio Líquido',
                        '% de Comissão',
                        'Vl. a Receber',
                    ],
                rotinaIntegracao: importaListaComissoesOmint,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoesSegundoLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'N° Prévia',
                        'Dt. Comissão',
                        'Produto',
                        'N° Parcela',
                        'Apólice',
                        'Nº Endosso',
                        'Bilhete',
                        'Segurado / Estipulante',
                        'Tipo de Comissão',
                        'Premio Líquido',
                        '% de Comissão',
                        'Vl. a Receber',
                        'Cnpj',
                    ],
                rotinaIntegracao: importaListaComissoesOmintSegundoLayout,
            },
        ],
        ordem: 170,
    },
    {
        id: 180,
        descricao: 'PASI',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 180,
    },
    {
        id: 190, // HARDCODE.idInstituicaoFinanceiraPortoSeguro
        descricao: 'Porto Seguro',
        SvgLogo: SvgImageParceirosPortoSeguroLogo,
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosPortoSeguroConsorcioLogo,
        //svgConsorcioLogoMl: '25',
        primeirasParcelasList: [
            {id: 1, descricao: '1 parcela'},
            {id: 3, descricao: '3 parcelas'},
            {id: 5, descricao: '5 parcelas'},
            {id: 12, descricao: '12 parcelas'},
            {id: 24, descricao: '24 parcelas'},
        ],
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Porto Seguro Cia de Seguros Gerais',
                        'APÓLICE Nº',
                        'SEGURO DE VIDA INDIVIDUAL',
                        'Os Capitais Segurados e Prêmios deste Seguro serão atualizados anualmente, no aniversário da apólice, com base na variação',
                    ],
                rotinaIntegracao: importaApolicePortoSeguro,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaPortoSeguro,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoConsorcio,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoConsorcio,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'PROPOSTA E CONTRATO DE PARTICIPAÇÃO EM GRUPO', 
                        'DE CONSÓRCIO SEGMENTO BENS IMÓVEIS',
                        'PORTO SEGURO ADMINISTRADORA DE CONSÓRCIOS LTDA',
                    ],
                rotinaIntegracao: importaConsorcioBensImoveisPortoSeguro,
            },
        ],
        ordem: 190,
    },
    {
        id: 200,
        descricao: 'Previsul',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 200,
    },
    {
        id: 210,
        descricao: 'Prudential',
        SvgLogo: SvgImageParceirosPrudentialLogo,
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoProposta,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Prudential do Brasil Seguros de Vida S.A.',
                        'PROPOSTA DE CONTRATAÇÃO DE SEGURO', 
                        'A seguradora terá o prazo de 15 (quinze) dias para manifestar-se sobre a Proposta. A contagem do prazo de 15 (quinze) dias',
                    ],
                rotinaIntegracao: importaPropostaPrudential,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaPrudential,
                classeAjuste: [
                    {id: 'STANDARD', idConversao: 'STANDARD'},
                    {id: 'CLASSE-A', idConversao: 'CLASSE A'},
                    {id: 'CLASSE-B', idConversao: 'CLASSE B'},
                    {id: 'CLASSE-C', idConversao: 'CLASSE C'},
                    {id: 'CLASSE-D', idConversao: 'CLASSE D'},
                    {id: 'CLASSE-E', idConversao: 'CLASSE E'},
                    {id: 'CLASSE-F', idConversao: 'CLASSE F'},
                    {id: 'FUMANTE-STANDARD', idConversao: 'FUMANTE-STANDARD'},
                    {id: 'NÃO-FUMANTE-STANDARD', idConversao: 'NÃO FUMANTE-STANDARD'},
                    {id: 'NÃO-FUMANTE-CLASSE-A', idConversao: 'NÃO FUMANTE-CLASSE A'},
                    {id: 'NÃO-FUMANTE-CLASSE-B', idConversao: 'NÃO FUMANTE-CLASSE B'},
                    {id: 'NÃO-FUMANTE-CLASSE-C', idConversao: 'NÃO FUMANTE-CLASSE C'},
                    {id: 'NÃO-FUMANTE-CLASSE-D', idConversao: 'NÃO FUMANTE-CLASSE D'},
                    {id: 'NÃO-FUMANTE-CLASSE-E', idConversao: 'NÃO FUMANTE-CLASSE E'},
                    {id: 'NÃO-FUMANTE-CLASSE-F', idConversao: 'NÃO FUMANTE-CLASSE F'},
                ],
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        //'The Prudential Insurance Company of America', 
                        'Detalhes da Apólice',
                        'Dados da Apólice',
                        'Não contestação a partir de:',
                        'Idade na Emissão:',
                        'Descrição das Coberturas',
                        '1) Valor já incluso no prêmio líquido por cobertura.',
                    ],
                rotinaIntegracao: importaApolicePrudential,
                statusApolice: statusApolicePrudential,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaPrudential,
                statusCobertura: statusCoberturaPrudential,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApoliceSiteCliente,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Dados do Seguro',
                        'Descrição das situações protegidas',
                        '1) Valor já incluso no prêmio líquido por cobertura.',
                        //'Prudential do Brasil reforça a importância de preservar o sigilo das informações enviadas pelo Banco',
                        'Os valores apresentados indicam prêmio de cada cobertura e estão sujeitos a correções e atualizações monetárias.',
                        'O Capital Segurado será atualizado anualmente pelo IPCA/IBGE, conforme previsto nas Condições Gerais',
                    ],
                rotinaIntegracao: importaApolicePrudentialSiteCliente,
                statusApolice: statusApolicePrudential,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaPrudential,
                statusCobertura: statusCoberturaPrudential,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacaoConsultorFinanceiro,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    'Apólice',
                    'Proposta',
                    'Proposta Eletrônica',
                    'CPF / CNPJ do titular',
                    'Agência do titular',
                    'Conta corrente do titular',
                    'Dígito da conta do titular',
                    'Canal de Venda',
                    'Forma de Adesão',
                    'Regional Serviço',
                    'Estado Agência Serviço',
                    'Agência Serviço',
                    'MFB Serviço',
                    'Consultor Serviço',
                    'CPD Serviço',
                    'CPD MFB Serviço',
                    'Emissão',
                    'Idade na Emissão',
                    'Idade na Emissão do Resp. Pagto.',
                    'Data Início Vigência Apólice',
                    'Contestação',
                    'Não contestação a partir de',
                    'Status Apólice',
                    'Tipo de Grupo Status Apólice',
                    'Grupo de Motivo Rejeição',
                    'Proposta Pendente já Aprovada por UW',
                    'Apólice Pendente Emissão',
                    'Not Taken',
                    'Tipo Proposta / Apólice',
                    'Tipo Proposta',
                    'Tipo Rejeição / Cancelamento',
                    'Motivo Rejeição / Cancelamento',
                    'Dt.Assinatura',
                    'Data Recebto. Proposta Agência',
                    'Dias Pend. Emissão',
                    'Data Entrega Apólice',
                    'Apólice Pendente Entrega',
                    'Dias Pend. Entrega',
                    'Digitou Entrega Apólice',
                    'Data Últ. Aniversário Apólice',
                    'Data Término Apólice',
                    'Agência Emissão',
                    'MFB Emissão',
                    'Consultor Emissão',
                    'CPD Emissão',
                    'CPD MFB Emissão',
                    'Apólice Orfã',
                    'Família Cob. Básica',
                    'Produto Cob. Básica',
                    'Classe Ajuste Mortalidade',
                    'Classe Ajuste DDR',
                    'Carta Ajuste Prêmio',
                    'Tem Ajuste Prêmio',
                    'Nome ou Nome Social do Cliente',
                    'Cliente',
                    'Sexo',
                    'Data de Nascimento',
                    'Mercado',
                    'CPF',
                    'Endereço',
                    'Bairro',
                    'Cidade',
                    'Estado',
                    'CEP',
                    'Telefone',
                    'Celular',
                    'Tel.Comercial',
                    'E-mail',
                    'Aceitou Comunicação Digital',
                    'Nome ou Nome Social do Resp. Pagto.',
                    'Resp. Pagto.',
                    'CPF / CNPJ Resp. Pagto.',
                    'Endereço Resp. Pagto.',
                    'Bairro Resp. Pagto.',
                    'Cidade Resp. Pagto.',
                    'Estado Resp. Pagto.',
                    'CEP Resp. Pagto.',
                    'Telefone Resp. Pagto.',
                    'Celular Resp. Pagto.',
                    'Telefone (Comercial) Resp. Pagto.',
                    'E-mail Resp. Pagto.',
                    'Resp. Pagto. Aceitou Comunicação Digital',
                    'Periodicidade Pagto.',
                    'Forma Pagto.',
                    'Banco do Resp. Pagto.',
                    'Número da Agência Bancária do Resp. Pagto.',
                    'Número da Conta Bancária do Resp. Pagto.',
                    'Administradora do Cartão de Crédito do Resp. Pagto.',
                    'Número Cartão Crédito do Resp. Pagto.',
                    'Ano Expiração Cartão do Resp. Pagto.',
                    'Mês Expiração Cartão do Resp. Pagto.',
                    'Ano/Mês Expiração Cartão do Resp. pelo Pagamento',
                    'Pago até',
                    'Dia escolhido para pagamento',
                    'Vencimento do Próximo Prêmio',
                    'Vencido Em',
                    'Dias Atraso',
                    'Nome do Cliente Exigências',
                    'Cliente Exigências',
                    'Apólice Origem Mudança Seguro',
                    'Usuário Digitou Proposta (Ingenium)',
                    'Data Digitou Proposta',
                    'Digitou Proposta',
                    'Gerou Exigência ASM',
                    'Data Gerou Exigência ASM',
                    'Cliente Alterou Após Gerar ASM',
                    'Usuário Realizou Clear Case (Ingenium)',
                    'Nome Usuário Realizou Clear Case (Ingenium)',
                    'Realizou Clear Case',
                    'Data Realizou Quality Review',
                    'Realizou Quality Review',
                    'Responsável UW (Ingenium)',
                    'Nome Responsável UW (Ingenium)',
                    'Cobertura',
                    'Produto',
                    'Produto',
                    'Produto Orig.',
                    'Produto Orig.',
                    'Família Prod. Orig.',
                    'Família Prod. Orig.',
                    'Tipo Família Produto Original',
                    'Tipo Cobertura Orig.',
                    'Classe Ajuste',
                    'Data Decisão UW Cobertura',
                    'Status Cobertura',
                    'Tipo de Grupo Status Cobertura',
                    'Tipo de Renovação',
                    'Autorizo todas as extensões de vigência da cobertura assinalada acima',
                    'Cobertura Tem Renovação',
                    'Prêmio Aproximado (*)',
                    'Valor do Prêmio Após Renovação Core (c/imposto)',
                    'Valor do Prêmio Após Renovação (c/imposto)',
                    'Data Renovação/Extensão de Vigência',
                    'Limite Entrega (**)',
                    'Status da Criação do PDF da Renovação Programada',
                    'Status da Renovação da Cobertura',
                    'Extensão de Vigência',
                    'Canc. Real Cob.',
                    'Data Reabilitação',
                    'Qtde. Reabilitações',
                    'Data Alteração do Prêmio Cobertura',
                    'Término Cobertura',
                    'Data Termino Real Cobertura',
                    'Data da Inclusão',
                    'Data da Alteração',
                    'Vr. Face',
                    'Vr. Taxa Prêmio Extra',
                    'Motivo Prêmio Extra',
                    'Prêmio Extra Anual',
                    'Duração Prêmio Extra',
                    'Vr. Antecipação do Benefício',
                    'Valor do Benefício',
                    'CS',
                    'CS Morte Acidental',
                    'CS PD',
                    'CS DDR',
                    'C.S. Antecipação Especial Vig.',
                    'Vr. HC',
                    'Vr. Assistência Funeral',
                    'Prêmio Líquido',
                    'IOF',
                    'Prêmio',
                    'PA s/ IOF',
                    'PA',
                    'Vr. Face Orig.',
                    'CS Orig.',
                    'CS Morte Acidental Orig.',
                    'CS PD Orig.',
                    'CS DDR Orig.',
                    'Vr. HC Orig.',
                    'Vr. Assistência Funeral Orig.',
                    'PA s/ IOF Orig.',
                    '% FYC',
                    'AFYC Projetado*',
                    'Data do Cálculo',
                    'Prêmio Calc.',
                    'Vencimento do Próximo Prêmio Calc.',
                    'Valor a Pagar sem IOF',
                    'IOF Reab.',
                    'Valor a Pagar com IOF',
                    'Gerar Termo Aditivo',
                    'Datas Término Vigência',
                    /*
                    "Apólice",
                    "Proposta",
                    "Consultor Financeiro Serviço",
                    "Emissão",
                    "Status Apólice",
                    "Tipo de Grupo Status Apólice",
                    "Consultor Financeiro Emissão",
                    "Nome ou Nome Social do Cliente",//"Nome do Cliente",
                    "Sexo",
                    "Data de Nascimento",
                    "CPF",
                    "Endereço",
                    "Bairro",
                    "Cidade",
                    "Estado",
                    "CEP",
                    "Telefone",
                    "Celular",
                    "Tel.Comercial",
                    "E-mail",
                    "Nome ou Nome Social do Resp. Pagto.",//"Nome do Resp. Pagto.",
                    "CPF / CNPJ Resp. Pagto.",
                    "Endereço Resp. Pagto.",
                    "Bairro Resp. Pagto.",
                    "Cidade Resp. Pagto.",
                    "Estado Resp. Pagto.",
                    "CEP Resp. Pagto.",
                    "Telefone Resp. Pagto.",
                    "Celular Resp. Pagto.",
                    "Telefone (Comercial) Resp. Pagto.",
                    "E-mail Resp. Pagto.",
                    "Periodicidade Pagto.",
                    "Forma Pagto.",
                    "Cobertura",
                    "Produto",
                    "Produto",
                    "Classe Ajuste",
                    "Status Cobertura",
                    "Tipo de Grupo Status Cobertura",
                    "Tipo de Renovação",
                    "Cobertura Tem Renovação",
                    "Prêmio Aproximado (*)",
                    "Valor do Prêmio Após Renovação Core (c/imposto)",
                    "Valor do Prêmio Após Renovação (c/imposto)",
                    "Data Renovação/Extensão de Vigência",
                    "Término Cobertura",
                    "Vr. Face",
                    "Vr. Taxa Prêmio Extra",
                    "Motivo Prêmio Extra",
                    "Prêmio Extra Anual",
                    "Duração Prêmio Extra",
                    "Valor do Benefício",
                    "CS",
                    "Prêmio Líquido",
                    "IOF",
                    "Prêmio",
                    "PA",
                    */
                ],
                rotinaIntegracao: importaListaApolicesPrudentialImplantacaoConsultorFinanceiroLP,
                statusApolice: statusApolicePrudential,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaPrudential,
                statusCobertura: statusCoberturaPrudential,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacaoLP,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    'Apólice',
                    'Proposta',
                    'Proposta Eletrônica',
                    'CPF / CNPJ do titular',
                    'Agência do titular',
                    'Conta corrente do titular',
                    'Dígito da conta do titular',
                    'Canal de Venda',
                    'Forma de Adesão',
                    'Regional Serviço',
                    'Estado Agência Serviço',
                    'Agência Serviço',
                    'MFB Serviço',
                    'LP Serviço',
                    'CPD Serviço',
                    'CPD MFB Serviço',
                    'Emissão',
                    'Idade na Emissão',
                    'Idade na Emissão do Resp. Pagto.',
                    'Data Início Vigência Apólice',
                    'Contestação',
                    'Não contestação a partir de',
                    'Status Apólice',
                    'Tipo de Grupo Status Apólice',
                    'Grupo de Motivo Rejeição',
                    'Proposta Pendente já Aprovada por UW',
                    'Apólice Pendente Emissão',
                    'Not Taken',
                    'Tipo Proposta / Apólice',
                    'Tipo Proposta',
                    'Tipo Rejeição / Cancelamento',
                    'Motivo Rejeição / Cancelamento',
                    'Dt.Assinatura',
                    'Data Recebto. Proposta Agência',
                    'Dias Pend. Emissão',
                    'Data Entrega Apólice',
                    'Apólice Pendente Entrega',
                    'Dias Pend. Entrega',
                    'Digitou Entrega Apólice',
                    'Data Últ. Aniversário Apólice',
                    'Data Término Apólice',
                    'Agência Emissão',
                    'MFB Emissão',
                    'LP Emissão',
                    'CPD Emissão',
                    'CPD MFB Emissão',
                    'Apólice Orfã',
                    'Família Cob. Básica',
                    'Produto Cob. Básica',
                    'Classe Ajuste Mortalidade',
                    'Classe Ajuste DDR',
                    'Carta Ajuste Prêmio',
                    'Tem Ajuste Prêmio',
                    'Nome ou Nome Social do Cliente',
                    'Cliente',
                    'Sexo',
                    'Data de Nascimento',
                    'Mercado',
                    'CPF',
                    'Endereço',
                    'Bairro',
                    'Cidade',
                    'Estado',
                    'CEP',
                    'Telefone',
                    'Celular',
                    'Tel.Comercial',
                    'E-mail',
                    'Aceitou Comunicação Digital',
                    'Nome ou Nome Social do Resp. Pagto.',
                    'Resp. Pagto.',
                    'CPF / CNPJ Resp. Pagto.',
                    'Endereço Resp. Pagto.',
                    'Bairro Resp. Pagto.',
                    'Cidade Resp. Pagto.',
                    'Estado Resp. Pagto.',
                    'CEP Resp. Pagto.',
                    'Telefone Resp. Pagto.',
                    'Celular Resp. Pagto.',
                    'Telefone (Comercial) Resp. Pagto.',
                    'E-mail Resp. Pagto.',
                    'Resp. Pagto. Aceitou Comunicação Digital',
                    'Periodicidade Pagto.',
                    'Forma Pagto.',
                    'Banco do Resp. Pagto.',
                    'Número da Agência Bancária do Resp. Pagto.',
                    'Número da Conta Bancária do Resp. Pagto.',
                    'Administradora do Cartão de Crédito do Resp. Pagto.',
                    'Número Cartão Crédito do Resp. Pagto.',
                    'Ano Expiração Cartão do Resp. Pagto.',
                    'Mês Expiração Cartão do Resp. Pagto.',
                    'Ano/Mês Expiração Cartão do Resp. pelo Pagamento',
                    'Pago até',
                    'Dia escolhido para pagamento',
                    'Vencimento do Próximo Prêmio',
                    'Vencido Em',
                    'Dias Atraso',
                    'Nome do Cliente Exigências',
                    'Cliente Exigências',
                    'Apólice Origem Mudança Seguro',
                    'Usuário Digitou Proposta (Ingenium)',
                    'Data Digitou Proposta',
                    'Digitou Proposta',
                    'Gerou Exigência ASM',
                    'Data Gerou Exigência ASM',
                    'Cliente Alterou Após Gerar ASM',
                    'Usuário Realizou Clear Case (Ingenium)',
                    'Nome Usuário Realizou Clear Case (Ingenium)',
                    'Realizou Clear Case',
                    'Data Realizou Quality Review',
                    'Realizou Quality Review',
                    'Responsável UW (Ingenium)',
                    'Nome Responsável UW (Ingenium)',
                    'Cobertura',
                    'Produto',
                    'Produto',
                    'Produto Orig.',
                    'Produto Orig.',
                    'Família Prod. Orig.',
                    'Família Prod. Orig.',
                    'Tipo Família Produto Original',
                    'Tipo Cobertura Orig.',
                    'Classe Ajuste',
                    'Data Decisão UW Cobertura',
                    'Status Cobertura',
                    'Tipo de Grupo Status Cobertura',
                    'Tipo de Renovação',
                    'Autorizo todas as extensões de vigência da cobertura assinalada acima',
                    'Cobertura Tem Renovação',
                    'Prêmio Aproximado (*)',
                    'Valor do Prêmio Após Renovação Core (c/imposto)',
                    'Valor do Prêmio Após Renovação (c/imposto)',
                    'Data Renovação/Extensão de Vigência',
                    'Limite Entrega (**)',
                    'Status da Criação do PDF da Renovação Programada',
                    'Status da Renovação da Cobertura',
                    'Extensão de Vigência',
                    'Canc. Real Cob.',
                    'Data Reabilitação',
                    'Qtde. Reabilitações',
                    'Data Alteração do Prêmio Cobertura',
                    'Término Cobertura',
                    'Data Termino Real Cobertura',
                    'Data da Inclusão',
                    'Data da Alteração',
                    'Vr. Face',
                    'Vr. Taxa Prêmio Extra',
                    'Motivo Prêmio Extra',
                    'Prêmio Extra Anual',
                    'Duração Prêmio Extra',
                    'Vr. Antecipação do Benefício',
                    'Valor do Benefício',
                    'CS',
                    'CS Morte Acidental',
                    'CS PD',
                    'CS DDR',
                    'C.S. Antecipação Especial Vig.',
                    'Vr. HC',
                    'Vr. Assistência Funeral',
                    'Prêmio Líquido',
                    'IOF',
                    'Prêmio',
                    'PA s/ IOF',
                    'PA',
                    'Vr. Face Orig.',
                    'CS Orig.',
                    'CS Morte Acidental Orig.',
                    'CS PD Orig.',
                    'CS DDR Orig.',
                    'Vr. HC Orig.',
                    'Vr. Assistência Funeral Orig.',
                    'PA s/ IOF Orig.',
                    '% FYC',
                    'AFYC Projetado*',
                    'Data do Cálculo',
                    'Prêmio Calc.',
                    'Vencimento do Próximo Prêmio Calc.',
                    'Valor a Pagar sem IOF',
                    'IOF Reab.',
                    'Valor a Pagar com IOF',
                    'Gerar Termo Aditivo',
                    'Datas Término Vigência',
                    /*
                    0 - "Apólice",
                    1 - "Proposta",
                    2 - "LP Serviço",
                    3 - "Emissão",
                    4 - "Status Apólice",
                    5 - "Tipo de Grupo Status Apólice",
                    6 - "LP Emissão",
                    7 - "Nome ou Nome Social do Cliente",//"Nome do Cliente",
                    8 - "Sexo",
                    9 - "Data de Nascimento",
                    10 - "CPF",
                    11 - "Endereço",
                    12 - "Bairro",
                    13 - "Cidade",
                    14 - "Estado",
                    15 - "CEP",
                    16 - "Telefone",
                    17 - "Celular",
                    18 - "Tel.Comercial",
                    19 - "E-mail",
                    20 - "Nome ou Nome Social do Resp. Pagto.",//"Nome do Resp. Pagto.",
                    21 - "CPF / CNPJ Resp. Pagto.",
                    22 - "Endereço Resp. Pagto.",
                    23 - "Bairro Resp. Pagto.",
                    24 - "Cidade Resp. Pagto.",
                    25 - "Estado Resp. Pagto.",
                    26 - "CEP Resp. Pagto.",
                    27 - "Telefone Resp. Pagto.",
                    28 - "Celular Resp. Pagto.",
                    29 - "Telefone (Comercial) Resp. Pagto.",
                    30 - "E-mail Resp. Pagto.",
                    31 - "Periodicidade Pagto.",
                    32 - "Forma Pagto.",
                    33 - "Cobertura",
                    34 - "Produto",
                    35 - "Produto",
                    36 - "Classe Ajuste",
                    37 - "Status Cobertura",
                    38 - "Tipo de Grupo Status Cobertura",
                    39 - "Tipo de Renovação",
                    40 - "Cobertura Tem Renovação",
                    41 - "Prêmio Aproximado (*)",
                    42 - "Valor do Prêmio Após Renovação Core (c/imposto)",
                    43 - "Valor do Prêmio Após Renovação (c/imposto)",
                    44 - "Data Renovação/Extensão de Vigência",
                    45 - "Término Cobertura",
                    46 - "Vr. Face",
                    47 - "Vr. Taxa Prêmio Extra",
                    48 - "Motivo Prêmio Extra",
                    49 - "Prêmio Extra Anual",
                    50 - "Duração Prêmio Extra",
                    51 - "Valor do Benefício",
                    52 - "CS",
                    53 - "Prêmio Líquido",
                    54 - "IOF",
                    55 - "Prêmio",
                    56 - "PA",
                    */
                ],
                rotinaIntegracao: importaListaApolicesPrudentialImplantacaoConsultorFinanceiroLP,
                statusApolice: statusApolicePrudential,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaPrudential,
                statusCobertura: statusCoberturaPrudential,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacaoSemAgente,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    "Apólice",
                    "Proposta",
                    "Emissão",
                    "Status Apólice",
                    "Tipo de Grupo Status Apólice",
                    "Nome ou Nome Social do Cliente",//"Nome do Cliente",
                    "Sexo",
                    "Data de Nascimento",
                    "CPF",
                    "Endereço",
                    "Bairro",
                    "Cidade",
                    "Estado",
                    "CEP",
                    "Telefone",
                    "Celular",
                    "Tel.Comercial",
                    "E-mail",
                    "Nome ou Nome Social do Resp. Pagto.",//"Nome do Resp. Pagto.",
                    "CPF / CNPJ Resp. Pagto.",
                    "Endereço Resp. Pagto.",
                    "Bairro Resp. Pagto.",
                    "Cidade Resp. Pagto.",
                    "Estado Resp. Pagto.",
                    "CEP Resp. Pagto.",
                    "Telefone Resp. Pagto.",
                    "Celular Resp. Pagto.",
                    "Telefone (Comercial) Resp. Pagto.",
                    "E-mail Resp. Pagto.",
                    "Periodicidade Pagto.",
                    "Forma Pagto.",
                    "Cobertura",
                    "Produto",
                    "Produto",
                    "Classe Ajuste",
                    "Status Cobertura",
                    "Tipo de Grupo Status Cobertura",
                    "Tipo de Renovação",
                    "Cobertura Tem Renovação",
                    "Prêmio Aproximado (*)",
                    "Valor do Prêmio Após Renovação Core (c/imposto)",
                    "Valor do Prêmio Após Renovação (c/imposto)",
                    "Data Renovação/Extensão de Vigência",
                    "Término Cobertura",
                    "Vr. Face",
                    "Vr. Taxa Prêmio Extra",
                    "Motivo Prêmio Extra",
                    "Prêmio Extra Anual",
                    "Duração Prêmio Extra",
                    "Valor do Benefício",
                    "CS",
                    "Prêmio Líquido",
                    "IOF",
                    "Prêmio",
                    "PA",
                ],
                rotinaIntegracao: importaListaApolicesPrudentialImplantacaoSemAgente,
                statusApolice: statusApolicePrudential,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaPrudential,
                statusCobertura: statusCoberturaPrudential,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaCobrancas,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCobranca,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'Agência-pendente',
                        'MFB',
                        'LP',
                        'Dias \nAtraso',
                        'Apólice',
                        'Resp. \nPagto.',
                        'Segurado',
                        'Telefone Resp. \nPagto.',
                        'Celular Resp. \nPagto.',
                        'Telefone (Comercial) \nResp. Pagto.',
                        'E-mail Resp. Pagto.',
                        'Periodicidade \nPagto.',
                        'Forma \nPagto.',
                        'Mês/Ano \nCartão',
                        'Emissão',
                        'Pago até',
                        'Vencido Em',
                        'Última Mensagem Retorno Cobrança Rejeitada',
                        'Prêmio',
                    ],
                rotinaIntegracao: importaListaCobrancasPrudential,
                tipoPeriodicidadePagtoPremio: tipoPeriodicidadePagtoPremioMAG,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'Escritório',
                        'Asssessor',
                        'CPD',
                        'Data Geração Comissão Direta',
                        'Apólice',
                        'Cobertura',
                        'Prêmio Líquido',
                        '% Co-corretagem',
                        'FYC',
                        'Renovação',
                        'Descrição do Produto',
                        'Vr. Face de Comissão',
                        'Ano de Pagamento da Comissão',
                        'Mês Pago Até',
                        'Periodicidade Pagto.',
                        'CPD do Gestor',
                        'Início Co-corretagem',
                        'Dt.Assinatura',
                        'Dt.Emissão',
                        'Produto',
                        'Nome do Cliente',
                    ],
                rotinaIntegracao: importaListaComissoesPrudential,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaComissoesSegundoLayout,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'Número da Transação Incentive',
                        'Ano',
                        'Mês',
                        'Nivel',
                        'Escritório',
                        'Assessor',
                        'CPD',
                        'Data Geração Comissão Direta',
                        'Apólice',
                        'Proposta',
                        'Cobertura',
                        'Prêmio Líquido',
                        //'% Comissão Global',
                        '% Comissão',
                        'FYC',
                        'Comissão Renovação',
                        'Comissão Total',
                        'Produto',
                        'Descrição do Produto',
                        'Vr. Face de Comissão',
                        'Ano de Pagamento',
                        'Mês Pago',
                        'Periodicidade Pagamento',
                        'Substituição de Apólice',
                        'Dt.Assinatura',
                        'Dt.Emissão',
                        'Nome do Cliente',
                        'CPF do Cliente',
                    ],
                rotinaIntegracao: importaListaComissoesPrudentialSegundoLayout,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaRecapture,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoComissao,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        'Ano',
                        'Mês',
                        'Nivel',
                        'Escritório',
                        'Assessor',
                        'CPD',
                        'Apólice',
                        'Proposta',
                        'Cobertura',
                        'Tipo de Atividade',
                        'Dt.Emissão',
                        'Canc. Real Cob.',
                        'Ano Cancelamento Cobertura',
                        '% Desconto Recapture',
                        'Comissão Direta',
                        'Valor Recapture',
                        'Produto',
                        'Nome do Cliente',
                        'CPF do Cliente',
                        'Tipo de Recapture',
                        'Prêmio',
                    ],
                rotinaIntegracao: importaListaRecapturePrudential,
            },
        ],
        integracaoAvulso: [
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'VIDA PRUDENTIAL', 
                        'Contratando o seguro de vida da Prudential do Brasil você e as pessoas escolhidas por',// vocês estarão preparadas',
                        'EVOLUÇÃO DA COBERTURA BÁSICA',
                        'Essa tabela exibe os pagamentos ao longo do tempo e o valor que estará disponível para resgate, caso haja interrupção do plano.',
                    ],
                rotinaIntegracao: importaCotacaoPrudentialTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'VIDA PRUDENTIAL', 
                        'Contratando o seguro de vida da Prudential do Brasil você e as pessoas escolhidas por',// vocês estarão preparadas',
                        'EVOLUÇÃO DA COBERTURA BÁSICA',
                        'Essa tabela exibe os pagamentos ao longo do tempo e os valores caso haja interrupção do plano.', // novo texto em 26/08/2026
                    ],
                rotinaIntegracao: importaCotacaoPrudentialTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'VIDA PRUDENTIAL', 
                        'Contratando o seguro de vida da Prudential do Brasil você e as pessoas escolhidas por',// vocês estarão preparadas',
                        'Evolução da Cobertura Básica',
                        'Essa tabela exibe os pagamentos ao longo do tempo e o valor que estará disponível para resgate, caso haja interrupção do plano.',
                    ],
                rotinaIntegracao: importaCotacaoPrudentialTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        //'Prudential do Brasil Seguros S.A.',
                        'Prudential do Brasil Seguros',
                        'Código p/ interligar o LPI com o DB Client',
                        'DESCRIÇÃO DOS BENEFÍCIOS EM CASO DE:',
                        'As informações indicadas neste formulário são simulações, não constituindo compromisso ou responsabilidade entre ambas as partes, podendo ser modificadas.',
                    ],
                rotinaIntegracao: importaCotacaoPrudentialTabelaEvolucaoValorResgateLifePlanner,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.XLSX,
                cabecalho: 7,
                chaveIntegracao:
                    [
                        null,
                        "Anos",
                        "Capital Segurado",
                        "Aporte Mensal",
                        "Aporte Anual",
                        "Aporte Acumulado",
                        "Resgate Bruto*",
                        null,
                        "Invalidez Acidental",
                        null,
                        null,
                    ],
                rotinaIntegracao: importaCotacaoPrudentialXPTabelaEvolucaoValorResgateAtual,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
            {
                XLSXPDF: HARDCODE.XLSX,
                cabecalho: 7,
                chaveIntegracao:
                    [
                        null,
                        "Anos",
                        "Capital Segurado",
                        "Aporte Anual",
                        "Aporte Acumulado",
                        "Resgate Bruto*",
                        null,
                        "Invalidez Acidental",
                        null,
                    ],
                rotinaIntegracao: importaCotacaoPrudentialXPTabelaEvolucaoValorResgateAntiga,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
        ],
        ordem: 210,
    },
    {
        id: 215, // HARDCODE.idInstituicaoFinanceiraRacon
        descricao: 'Racon',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosRaconConsorcioLogo,
        //svgConsorcioLogoMl: '22',
        corretoraValores: 'N',
        seguradora: 'N',
        ordem: 215,
    },
    {
        id: 217, // HARDCODE.idInstituicaoFinanceiraRodobens
        descricao: 'Rodobens',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosRodobensConsorcioLogo,
        //svgConsorcioLogoMl: '8',
        corretoraValores: 'N',
        seguradora: 'N',
        ordem: 217,
    },
    {
        id: 220,
        descricao: 'Sancor',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 220,
    },
    {
        id: 225, // HARDCODE.idInstituicaoFinanceiraSantander
        descricao: 'Santander',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosSantanderConsorcioLogo,
        //svgConsorcioLogoMl: '8',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'https://www.santander.com.br',
                        'BENEFICIÁRIO DO SEGURO',
                        'ZURICH SANTANDER BRASIL SEGUROS S.A., CNPJ: 06.136.920/0001-18',
                        'Este seguro é por prazo determinado tendo a Seguradora à faculdade de não renovar a apólice na data de vencimento',
                        'A SEGURADORA informa que cumpre integralmente a Lei de Proteção de Dados do Brasil e garante',
                    ],
                rotinaIntegracao: importaApoliceSantander,
                //statusApolice: statusApoliceSantander,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaSantander,
            },
        ],
        ordem: 225,
    },
    {
        id: 230,
        descricao: 'Unimed',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 273,
    },
    {
        id: 233, // HARDCODE.idInstituicaoFinanceiraSafra
        descricao: 'Safra',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'S',
        seguradora: 'N',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentos,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Relatório Mensal',
                        'Marcação Mercado',
                        'Vencimento do suitability',
                        'por favor, contacte a Central de Atendimento Safra para saber como regularizar.',
                        //'Rent. (%) % CDI Rent. (%) % CDI Rent. (%) % CDI',
                        'vinculação/desvinculação de previdência à conta corrente ou portabilidade não são considerados nos cálculos de rentabilidade para o mês de ocorrência do evento.',
                        'Rentabilidade Histórica de Produtos',
                        'Posição de Investimentos',
                        'Investimentos Resumo Composição',
                        'Detalhamento de Fundos de Investimentos',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosSafra,
                tipoRecursoFinanceiro: [
                    {id: 'PÓS-FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPosFixado}, //suposição
                    {id: 'INFLAÇÃO', idConversao: HARDCODE.idTipoRecursoFinanceiroInflacao}, //suposição
                    {id: 'PRÉ-FIXADO', idConversao: HARDCODE.idTipoRecursoFinanceiroPreFixado}, //suposição
                    //{id: 'FUNDOS LISTADOS', idConversao: HARDCODE.idTipoRecursoFinanceiroFundosListados},
                    //{id: 'MULTIMERCADO', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
                    //{id: 'ALTERNATIVO', idConversao: HARDCODE.idTipoRecursoFinanceiroMultimercado},
                    {id: 'RENDA-VARIÁVEL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel}, //suposição
                    //{id: 'RENDA VARIÁVEL BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
                    //{id: 'RENDA VARIÁVEL GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaVariavel},
                    {id: 'RENDA-FIXA', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    //{id: 'RENDA FIXA BRASIL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    //{id: 'RENDA FIXA GLOBAL', idConversao: HARDCODE.idTipoRecursoFinanceiroRendaFixa},
                    {id: 'CORRETORA', idConversao: HARDCODE.idTipoRecursoFinanceiroInternacional},
                    {id: 'CARTEIRA-RECOMENDADA-BDR', idConversao: HARDCODE.idTipoRecursoFinanceiroInternacional},
                    {id: 'CURTO-PRAZO', idConversao: HARDCODE.idTipoRecursoFinanceiroCurtoPrazo},
                    {id: 'OP.-ESTRUTURADAS', idConversao: HARDCODE.idTipoRecursoFinanceiroCOE},
                ],
            },
        ],
        ordem: 233,
    },
    {
        id: 235, // HARDCODE.idInstituicaoFinanceiraServopa
        descricao: 'Servopa',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosServopaConsorcioLogo,
        //svgConsorcioLogoMl: '25',
        primeirasParcelasList: [
            {id: 1, descricao: '1 parcela'},
            {id: 3, descricao: '3 parcelas'},
            {id: 5, descricao: '5 parcelas'},
            {id: 12, descricao: '12 parcelas'},
            {id: 24, descricao: '24 parcelas'},
        ],
        corretoraValores: 'N',
        seguradora: 'N',
        ordem: 235,
    },
    {
        id: 240,
        descricao: 'Sompo',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 240,
    },
    {
        id: 245,
        descricao: 'SwissRe',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 245,
    },
    {
        id: 250,
        descricao: 'SulAmérica',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        /*integracaoAvulso: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoProposta,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'SulAmérica',
                        'ESTE DOCUMENTO FOI PRODUZIDO PELA SULAMÉRICA INVESTIMENTOS DTVM, COM FINS MERAMENTE INFORMATIVOS NÃO SE CARACTERIZANDO COMO OFERTA OU SOLICITAÇÃO DE INVESTIMENTO OU DESINVESTIMENTO DE ATIVOS.', 
                        'FUNDOS DE INVESTIMENTO NÃO CONTAM COM GARANTIA DO ADMINISTRADOR, DO GESTOR, DE QUALQUER MECANISMO DE SEGURO OU DO FUNDO GARANTIDOR DE CRÉDITO- FGC.',
                        'PARA AVALIAÇÃO DA PERFORMANCE DE UM FUNDO DE INVESTIMENTO, É RECOMENDÁVEL A ANÁLISE DE, NO MÍNIMO, 12 (DOZE) MESES.',
                    ],
                rotinaIntegracao: importaPropostaMAG,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaMAG,
            },
        ],*/
        ordem: 250,
    },
    {
        id: 260,
        descricao: 'Sura',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 260,
    },
    {
        id: 270,
        descricao: 'Tokio Marine',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 270,
    },
    {
        id: 272, // HARDCODE.idInstituicaoFinanceiraUne
        descricao: 'Une',
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosUneConsorcioLogo,
        //svgConsorcioLogoMl: '25',
        corretoraValores: 'N',
        seguradora: 'N',
        ordem: 272,
    },
    {
        id: 275, // HARDCODE.idInstituicaoFinanceiraXP
        descricao: 'XP',
        SvgLogo: SvgImageParceirosXPLogo,
        administradoraConsorcio: 'S',
        administradoraConsorcioLinkCaptacaoLeads: 'S',
        SvgConsorcioLogo: SvgImageParceirosXPConsorcioLogo,
        //svgConsorcioLogoMl: '25',
        corretoraValores: 'S',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoProposta,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoProposta,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Essa é a proposta do seu seguro de vida. Neste documento estão as características do produto que',
                        'O seguro de vida é garantido pela XP Vida e Previdência S.A., empresa do grupo XP Inc.', 
                        'Ao assinar esta proposta, o cliente declara que as informações fornecidas são verdadeiras e',
                        'O artigo 765 do Código Civil que estabelece: "o Segurado e o Segurador são obrigados a guardar na',
                    ],
                rotinaIntegracao: importaPropostaXP,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaXP,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoApolice,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Essa é a apólice do seu seguro de vida, onde você encontrará as informações para você e sua família se sentirem ainda',
                        'Apólice',
                        'O Seguro de Vida é garantido pela XP Vida e Previdência S.A., empresa do Grupo XP Inc.',
                        'Razão Social: XP Vida e Previdência S.A. CNPJ: 29.408.732/0001-05 Código SUSEP: 0403-1 Processo SUSEP: 15414.639330/2022-19',
                        'da apólice ou do aumento do capital segurado.',
                        'que o Banco XP ou a XP Vida e Previdência não poderão, em nenhuma hipótese, ser responsabilizados por débitos',
                        '',
                    ],
                rotinaIntegracao: importaApoliceXP,
                statusApolice: statusApoliceXP,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaXP,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesImplantacao,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoApolice,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                cabecalho: 0,
                chaveIntegracao:
                [
                    'Nº da conta',
                    'Nº da apólice',
                    'CPF',
                    'Nome do cliente',
                    'Data de nascimento',
                    'Data de emissão da apólice',
                    'Término da Vigência',
                    'Coberturas Contratadas',
                    'Periodicidade',
                    'PA',
                    'Capital Segurado',
                    'Forma de pag',
                    'Data de vencimento',
                    'Status'
                ],
                rotinaIntegracao: importaListaApolicesXPImplantacao,
                statusApolice: statusApoliceXP,
                tipoCoberturaSeguroVida: tipoCoberturaSeguroVidaXP,
                statusCobertura: statusCoberturaXP,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoFichaCadastral,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'FICHA CADASTRAL - X', // A XP protegeu os dados os colando como imagem e por isso inativamos a importação da Ficha Cadastral
                        'PESSOA FÍSICA',
                        'Indique as contas bancárias para as suas movimentações financeiras na XP',
                        'Conforme Circular Bacen nº 3.978/20 e Resolução CVM nº 50/2021, Pessoas Politicamente Expostas (PEP) são pessoas que estão ou estiveram, nos últimos 5 anos',
                        'DECLARAÇÃO DO RESPONSÁVEL PELO CADASTRAMENTO (USO EXCLUSIVO DA XP INVESTIMENTOS CCTVM S/A)',
                    ],
                rotinaIntegracao: importaFichaCadastralXP,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentos,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Data de Referência', 
                        'R E S U M O  D E  I N F O R M A Ç Õ E S  D A  C A R T E I R A',
                        'E S T AT Í S T I C A  H I S T Ó R I C A',//  ( D E S D E  I N I C I O )',
                        'H I S T Ó R I C O  P O R  E S T R AT É G I A',
                        'R E N T A B I L I D A D E  P O R  C L A S S E',
                        'R E N T A B I L I D A D E  X  B E N C H M A R K S',//  M E N S A L',
                        'Este material foi elaborado pela XP INVESTIMENTOS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS S.A., tem caráter meramente informativo',//, não constitui e nem deve ser',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosXP,
                tipoRecursoFinanceiro: tipoRecursoFinanceiroXP,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentos,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Data de Referência', 
                        'R E S U M O  D E  I N F O R M A Ç Õ E S  D A  C A R T E I R A',
                        'E S T AT Í S T I C A  H I S T Ó R I C A',//  ( D E S D E  I N I C I O )',
                        'H I S T Ó R I C O  P O R  E S T R AT É G I A',
                        'R E N T A B I L I D A D E  P O R  C L A S S E',
                        'R E N T A B I L I D A D E  X  B E N C H M A R K S', //  M E N S A L',
                        'Este material foi elaborado pela XP INVESTIMENTOS CORRETORA DE CAMBIO, TITULOS E VALORES MOBILIARIOS S/A., tem caráter meramente informativo',//, não constitui e nem deve ser',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosXP,
                tipoRecursoFinanceiro: tipoRecursoFinanceiroXP,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoPosicaoInvestimentos,
                XLSXPDF: HARDCODE.PDF,
                tipoAcessoArquivoNULL: HARDCODE.tipoAcessoArquivoPosicaoInvestimentos,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoCliente,
                chaveIntegracao:
                    [
                        'Data de Referência', 
                        'R E S U M O  D E  I N F O R M A Ç Õ E S  D A  C A R T E I R A',
                        'E S T AT Í S T I C A  H I S T Ó R I C A',//  ( D E S D E  I N I C I O )',
                        'H I S T Ó R I C O  P O R  E S T R AT É G I A',
                        'R E N T A B I L I D A D E  P O R  C L A S S E',
                        'R E N T A B I L I D A D E  X  B E N C H M A R K S', //  M E N S A L',
                        'Este material foi elaborado pela RICO CORRETORA DE TITULOS E VALORES MOBILIARIOS S.A., tem caráter meramente informativo',
                    ],
                rotinaIntegracao: importaPosicaoInvestimentosXP,
                tipoRecursoFinanceiro: tipoRecursoFinanceiroXP,
            },
        ],
        integracaoAvulso: [
            {
                XLSXPDF: HARDCODE.PDF,
                chaveIntegracao:
                    [
                        'proteções que foram simuladas para o seu momento de vida. Essa',
                        'cotação',
                        'A XP Corretora de Seguros é parte integrante da XP Inc., que concentra',
                        'AS INFORMAÇÕES CONTIDAS NESSA MENSAGEM TÊM CARÁTER MERAMENTE INFORMATIVO, NÃO VINCULANTE, NÃO CONSTITUI E NEM DEVE SER INTERPRETADO', // COMO SENDO SOLICITAÇÃO',
                        '10.558.797/0001-09 (“XP SEGUROS”). TODOS OS PRODUTOS DISTRIBUÍDOS PELA XP SEGUROS',
                        'PROVEEM DE SEGURADORAS REGISTRADAS NA SUSEP.',
                    ],
                rotinaIntegracao: importaCotacaoXPTabelaEvolucaoValorResgate,
                origemIntegracao: LABEL.seguroVida + ' - ' + LABEL.cotacao,
            },
        ],
        ordem: 275,
    },
    {
        id: 280,
        descricao: 'Zurich',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        ordem: 280,
    },
    {
        id: 900, // HARDCODE.idSeguradoraOutras
        descricao: 'Outras',
        administradoraConsorcio: 'N',
        administradoraConsorcioLinkCaptacaoLeads: 'N',
        corretoraValores: 'N',
        seguradora: 'S',
        integracao: [
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaTransferenciaClientes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoTransferenciaCliente,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "CPF Cliente",
                        "Agente",
                    ],
                rotinaIntegracao: importaListaTransferenciaClientesOutras,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaClientesAgentes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoClienteAgente,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "CPF Cliente",
                        "Nome Cliente",
                        "Instituição Financeira",
                        "Número Conta Cliente",
                        "Código Agente",
                    ],
                rotinaIntegracao: importaListaClientesAgentesOutras,
            },
            {
                tipoArquivo: HARDCODE.idTipoArquivoListaApolicesAgentes,
                XLSXPDF: HARDCODE.XLSX,
                tipoAcessoArquivoNULL: null,
                tipoAtualizacao: HARDCODE.tipoAtualizacaoApoliceAgente,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "Seguradora",
                        "Apólice",
                        "Agente Corretor de Seguros",
                        "% Divisão Comissão",
                        "Agente Corretor de Seguros 2",
                        "Agente Assessor Investimentos",
                    ],
                rotinaIntegracao: importaListaApolicesAgentesOutras,
            },
        ],
        integracaoAvulso: [
            {
                XLSXPDF: HARDCODE.XLSX,
                cabecalho: 0,
                chaveIntegracao:
                    [
                        "Parcelas",
                    ],
                rotinaIntegracao: importaParcelas,
                origemIntegracao: LABEL.financiamento,
            },
        ],
        ordem: 900,
    },
]

export default instituicaoFinanceiraList